<script>
import Vue from 'vue';
import { Toast } from 'vant';
import {ImagePreview} from 'vant';
// 加载中
import InnerLoading from '@/components/spinner/spinner.vue';
// 单选下拉
import Pop from '@/components/technician/temp/pop';
import PopArea from '@/components/technician/temp/popArea';
import DateTemp from '@/components/technician/temp/date';
import {blurRule,validateInput,} from '@/untils/common';
import {
  branchInfoList2,
  processGeneralsubmit,
  processIsinservice,
  processRemove,
  salespersonInfoList,
  branchInfoJudgeDistance,
  processIsBind, processIsCord, dynamicDataLocation, dynamicDataListSpecialManager,
  inspection_explain_details,
  device_manager_installInfo
} from "@/lib/request";
import {getLocalItem} from "@/untils/common";
import {ClientId} from "@/lib/cli";
import wx from "weixin-js-sdk";
// import {Dialog} from "vant";
Vue.use(Toast);
export default {
  name: 'temp',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    content:{
      type: String,
      default: ''
    },
    submitText:{
      type: String,
      default: ''
    },
    variablesObj:{
      type: Object,
      default: {}
    },
    newSiteId:{
      type: String,
      default: ''
    },
    siteIdObj:{
      type: Object,
      default: {}
    },
    flowNameObj:{
      type: Object,
      default: {}
    },
    returnObj:{
      type: Object,
      default: {}
    },
    formDefine:{
      type: Object,
      default: {}
    },
    formFields:{
      type: Array,
      default: []
    },
    historyList:{
      type: Array,
      default: function () {
        return []; // 使用工厂函数返回一个新的数组作为默认值
      }
    },
  },
  components:{
    InnerLoading,
    Pop,
    DateTemp,
    PopArea
  },
  data() {
    return {
      resultData_van:{},
      resultData:{},
      explainList:[],
      twoHalt:'',
      twoPermit:false,
      twoConfirmFlag:false,
      nameHeadFlag:false,
      siteIdInfoObj:{},
      maxLength:28,
      innerLoading:false,
      showPopup: this.value,
      createObj:{
        processInstanceId:'',
        formId:'',
        needSaveBrands:{},
        values:{}
      },
      isManClose: false,
      showPicker:false,
      showDatePicker:false,
      showPopAreaPicker:false,
      checkList:[],
      checkName:[],
      checkErrorList:[],
      areaList:{},
      itemObj:{},
      showPickerImg:false,
      fileVideoUrl:'/api/resource/oss/upload',//接口前缀加api
      headers:{
        'isEncrypt':true,
        'Authorization': 'Bearer ' + getLocalItem('access_token'),
        'clientid' : ClientId,
      },
      loading:false,
      imgFlag1: false,
      //是否显示进度条
      imgUploadPercent1: 0,
      //进度条的进度，
      isShowUploadImg1: false,
      //显示上传按钮
      imgForm1: {
        showVideoPath: "",  //回显的变量
      },
      fileList:[],
      longitude: '',//116.4484634399414,//
      latitude: '',//39.98253631591797,//
      subRateFlag:true,//ture时是编辑状态，false时不可编辑（提交按钮点击时为false）
      siteId:'',
      fixeCordObj:{},
      listDataInfo:[],
      disabledSubmitFlag:false,
    }
  },
  computed: {
    userUpdateForm(){
      return [this.formDefine].map(instance => {
        // // 网点编号推荐接口
        // if(instance.name&&instance?.name?.indexOf('网点编号')!==-1){
        //   // 拉萨市：渠道部 审核通过填网点编号，其他市区，专管员填网点编号
        //   let siteId = instance.fields?.find(
        //       field => field.id === 'siteid'
        //   )
        //   siteId.readOnly = true;
        //   if(this.variablesObj&&this.variablesObj.city){
        //     device_manager_installInfo({
        //       city:this.variablesObj.city
        //     }).then((res)=>{
        //       if(res){
        //         if(res.data){
        //           if(res.data.code===200){
        //             siteId.value = res.data.data;
        //           }else{
        //             this.$toast(res.data.msg);
        //             return false;
        //           }
        //         }
        //       }
        //     })
        //   }
        // }
        // 新版巡检表单变更 ，2026年四月份 上线新的一般巡检表单内容
        if(instance.name&&instance?.name?.indexOf('一般巡检')!==-1){
          const fields = instance.fields;
          // 定义映射关系：哪个选项字段控制哪个上传字段
          const hideRules = {
            'shootsConsignmentCertificate':'isConsignmentCertificate',
            'shootCertificate': 'certificateIsExist',
            'certificateIsValidity': 'certificateIsExist',
            'shootTitle': 'titleIsExist',
            'storefrontstyle': 'titleIsExist',
            'shootAnnouncement': 'announcementIsExist',
            'shootfireProtection': 'fireProtectionIsExist',
            'shootwelfareLotterySecurityArea': 'welfareLotteryIsFull',
            'shootwelfareLotteryIsFront': 'welfareLotteryIsScratch',
            'shootWarning': 'warningIsExist',
            'shootCreditSale': 'creditSaleIsExist',
            'shootVulgar': 'vulgarIsExist',
            'isFlammableImage':'isFlammable',
            'isChargingImage':'isCharging',
            'isElectricalAppliancesImage':'isElectricalAppliances',
            'isCameraUnification':'isCamera',
            'isCameraImage':'isCamera',
            'isTidyImage':'isTidy'
          };



          // 定义特殊规则：某些字段的隐藏条件不是"否"
          const specialHideRules = {
            'shootsConsignmentCertificate': {
              controlField: 'isConsignmentCertificate',
              hideWhenValue: '无'  // 值为"无"时隐藏
            },
            'shootwelfareLotterySecurityArea': {
              controlField: 'welfareLotteryIsFull',
              hideWhenValue: '是'  // 值为"是"时隐藏
            },
            'shootwelfareLotteryIsFront': {
              controlField: 'welfareLotteryIsScratch',
              hideWhenValue: '是'  // 值为"是"时隐藏
            }
          };

          // 构建字段映射表
          const fieldMap = new Map();
          fields.forEach(field => {
            fieldMap.set(field.id, field);
          });

          // 收集需要隐藏的字段
          const fieldsToHide = new Set();

          // 处理每个被控字段
          Object.entries(hideRules).forEach(([controlledId, controlId]) => {
            const controlField = fieldMap.get(controlId);
            if (controlField) {
              let shouldHide = false;

              // 检查是否有特殊规则
              if (specialHideRules[controlledId]) {
                const rule = specialHideRules[controlledId];
                shouldHide = controlField.value === rule.hideWhenValue;
              } else {
                // 默认规则：值为"否"时隐藏
                shouldHide = controlField.value === '否';
              }

              if (shouldHide) {
                fieldsToHide.add(controlledId);
                // 清空被控字段的值
                const controlledField = fieldMap.get(controlledId);
                if (controlledField) {
                  controlledField.value = '';
                  if (controlledField.files) {
                    controlledField.files = [];
                  }
                }
              }
            }
          });

          // 过滤掉需要隐藏的字段
          const filteredFields = fields.filter(field => !fieldsToHide.has(field.id));

          return {
            ...instance,
            fields: filteredFields
          };
        }
        // 阳光征召提交的数据，专管员审核基本信息表单
        if(instance.name&&instance?.name?.indexOf('文审')!==-1){
          // 处理错误类型和片区
          instance.fields.map((v)=> {
            // 新装机的文审的是否前往代销点字段只有拉萨市不能选，其他的地市都可选
            // 是否前往代销点
            if(v.id==='areyougo'){
              if(this.variablesObj?.city.includes('拉萨市')){
                v.value = '是'
                v.readOnly = true;
              }
            }
            // 片区
            if(v.id==='precinct'){
              if(this.variablesObj?.city.includes('拉萨市')){
                v.params.customDesign.values = v?.params?.customDesign?.values.filter(item => !item.label.includes('林芝'))
              }else if(this.variablesObj?.city.includes('林芝市')){
                v.params.customDesign.values = v?.params?.customDesign?.values.filter(item => !item.label.includes('拉萨'))
              }
            }
            // 错误类型
            if (v.id === "errorType") {
              // v?.params?.customDesign?.values
              v.checkTypeValue = [
                {label: '身份证正面不符'},
                {label: '身份证反面不符'},
                {label: '二寸证件照不符'},
                {label: '社会信用代码证不符'},
                {label: '企业年检合格证明不符'},
                {label: '企业信息报告不符'},
                {label: '退役军人证不符'},
                {label: '毕业证不符'},
                {label: '残疾证不符'},
                {label: '银行卡照片不符'},
                {label: '余额截图不符'},
                {label: '无犯罪证明不符'},
                {label: '房产证明不符'},
                {label: '代销网点类型不符'},
              ]

              const fieldMapping = {
                '个人信息': ['identityImage', 'twoinchPhoto'],
                '企业资质信息': ['uscc', 'aicoc', 'ecr'],
                '优抚类型信息': ['retirementimage', 'diploma', 'disabledcertificate'],
                '个人信用信息': ['policecertificate'],
                '代销网点类型': [],
                '财务信息': ['backcardimage', 'balanceimage'],
                '房产证明': ['leaseContract']
              };
              const fields = this.filteredActivities[0]?.formInfo?.fields;
              const fieldMap = {};
              if(fields&&fields.length>0){
                fields.map(field => {
                  fieldMap[field.id] = field;
                });
              }
              if (this.variablesObj.applicanttype === '法人') {
                const excludeLabels = ['无犯罪证明不符'];//, '无不良信息记录证明不符'
                if (this.variablesObj.treatmentType === '无') {
                  excludeLabels.push('退役军人证不符', '毕业证不符', '残疾证不符')
                } else if (this.variablesObj.treatmentType === '残障人士') {
                  excludeLabels.push('退役军人证不符', '毕业证不符')
                } else if (this.variablesObj.treatmentType === '退伍军人') {
                  excludeLabels.push('残疾证不符', '毕业证不符')
                } else if (this.variablesObj.treatmentType === '应届大学生') {
                  excludeLabels.push('残疾证不符', '退役军人证不符')
                }
                const values = v.checkTypeValue.filter(item => !excludeLabels.includes(item.label));
                v.checkTypeValue = [
                  {
                    title:"代销网点类型",
                    list: values.filter(item =>
                        ['代销网点类型不符'].includes(item.label)
                    )
                  },
                  {
                    title: "个人信息",
                    list: values.filter(item =>
                        ['身份证正面不符', '身份证反面不符', '二寸证件照不符'].includes(item.label)
                    )
                  },
                  {
                    title: "企业资质信息",
                    list: values.filter(item =>
                        ['社会信用代码证不符', '企业年检合格证明不符', '企业信息报告不符'].includes(item.label)
                    )
                  },
                  {
                    title: "优抚类型信息",
                    list: values.filter(item =>
                        ['退役军人证不符', '毕业证不符', '残疾证不符'].includes(item.label)
                    )
                  },
                  {
                    title: "个人信用信息",
                    list: values.filter(item =>
                        ['无犯罪证明不符'].includes(item.label)
                    )
                  },
                  // {
                  //   title: "社会关系信息",
                  //   list: values.filter(item =>
                  //       ['无不良信息记录证明不符'].includes(item.label)
                  //   )
                  // },

                  {
                    title: "财务信息",
                    list: values.filter(item =>
                        ['银行卡照片不符', '余额截图不符'].includes(item.label)
                    )
                  },{
                    title:"房产证明",
                    list: values.filter(item =>
                        ['房产证明不符'].includes(item.label)
                    )
                  }
                ];
                v.checkTypeValue = v.checkTypeValue.map(item => {
                  const result = {
                    title: item.title,
                    list: item.list || []
                  };

                  // 获取当前分类对应的字段ID数组
                  const fieldIds = fieldMapping[item.title] || [];

                  // 过滤出存在的字段
                  const matchedFields = fieldIds
                      .filter(id => fieldMap[id])
                      .map(id => ({
                        id: fieldMap[id].id,
                        name: fieldMap[id].name,
                        value: fieldMap[id].value
                      }));
                  // 如果有匹配的字段，添加 image 或 images 属性
                  if (matchedFields.length > 0) {
                    result.image = matchedFields;
                  }
                  return result;
                });
              } else {
                const excludeLabels = ['企业信息报告不符', '企业年检合格证明不符', '社会信用代码证不符'];//, '无不良信息记录证明不符'
                if (this.variablesObj.treatmentType === '无') {
                  excludeLabels.push('退役军人证不符', '毕业证不符', '残疾证不符')
                } else if (this.variablesObj.treatmentType === '残障人士') {
                  excludeLabels.push('退役军人证不符', '毕业证不符')
                } else if (this.variablesObj.treatmentType === '退伍军人') {
                  excludeLabels.push('残疾证不符', '毕业证不符')
                } else if (this.variablesObj.treatmentType === '应届大学生') {
                  excludeLabels.push('残疾证不符', '退役军人证不符')
                }
                const values = v.checkTypeValue.filter(item => !excludeLabels.includes(item.label));
                v.checkTypeValue = [
                  {
                    title:"代销网点类型",
                    list: values.filter(item =>
                        ['代销网点类型不符'].includes(item.label)
                    )
                  },
                  {
                    title: "个人信息",
                    list: values.filter(item =>
                        ['身份证正面不符', '身份证反面不符', '二寸证件照不符'].includes(item.label)
                    )
                  },
                  {
                    title: "企业资质信息",
                    list: values.filter(item =>
                        ['社会信用代码证不符', '企业年检合格证明不符', '企业信息报告不符'].includes(item.label)
                    )
                  },
                  {
                    title: "优抚类型信息",
                    list: values.filter(item =>
                        ['退役军人证不符', '毕业证不符', '残疾证不符'].includes(item.label)
                    )
                  },
                  {
                    title: "个人信用信息",
                    list: values.filter(item =>
                        ['无犯罪证明不符'].includes(item.label)
                    )
                  },
                  // {
                  //   title: "社会关系信息",
                  //   list: values.filter(item =>
                  //       ['无不良信息记录证明不符'].includes(item.label)
                  //   )
                  // },

                  {
                    title: "财务信息",
                    list: values.filter(item =>
                        ['银行卡照片不符', '余额截图不符'].includes(item.label)
                    )
                  },{
                    title:"房产证明",
                    list: values.filter(item =>
                        ['房产证明不符'].includes(item.label)
                    )
                  }
                ];
                v.checkTypeValue = v.checkTypeValue.map(item => {
                  const result = {
                    title: item.title,
                    list: item.list || []
                  };

                  // 获取当前分类对应的字段ID数组
                  const fieldIds = fieldMapping[item.title] || [];

                  // 过滤出存在的字段
                  const matchedFields = fieldIds
                      .filter(id => fieldMap[id])
                      .map(id => ({
                        id: fieldMap[id].id,
                        name: fieldMap[id].name,
                        value: fieldMap[id].value
                      }));
                  // 如果有匹配的字段，添加 image 或 images 属性
                  if (matchedFields.length > 0) {
                    result.image = matchedFields;
                  }
                  return result;
                });
              }
            }
          });

          //阳光征召资料审核流程：如果是拉萨市或者林芝市的地址，需要显示片区，否则不需要显示片区
          // const newEditVal =  this.variablesObj?.city !== '拉萨市'&&this.variablesObj?.city !== '林芝市';
          const newEditVal =  !this.variablesObj?.city.includes('拉萨市')&&!this.variablesObj?.city.includes('林芝市')
          // 资料审核
          const isPassType = instance.fields?.some(
              field=>field.id==='documentReview' && (field.value === '未通过')
          )
          const isFailType = instance.fields?.some(
              field=>field.id==='documentReview' && (field.value === '通过')
          )
          if(!isPassType&&!newEditVal&&!isFailType){
            return instance;
          }
          if(newEditVal&&isFailType){
            this.checkErrorList = [];
            // 创建新对象并过滤字段
            return {
              ...instance,
              // 如果是【不是拉萨市或者林芝市并且审核通过】时，去掉以下2个字段
              // precinct:片区
              // errorType:不合格的类型
              // fields: instance.fields.filter(field => !['precinct'].includes(field.id))
              fields:instance?.fields.filter(field => {
                // 过滤掉不需要的字段
                const shouldKeep = !['precinct','errorType'].includes(field.id);
                // 如果需要保留，同时处理value值
                // 不显示的字段时默认置空
                // console.log('不是拉萨市并且审核通过',shouldKeep);//
                if (!shouldKeep) {
                  field.value = ''; // 直接修改原对象
                  if(field.id==='precinct'){
                    field.value = '无';
                  }
                }
                return shouldKeep;
              })
            };
          }

          if(newEditVal){
            // 创建新对象并过滤字段
            return {
              ...instance,
              // 如果是【拉萨市或林芝市不通过】时，去掉以下1个字段
              // precinct:片区
              // fields: instance.fields.filter(field => !['precinct'].includes(field.id))
              fields:instance?.fields.filter(field => {
                // 过滤掉不需要的字段
                const shouldKeep = !['precinct'].includes(field.id);
                // 如果需要保留，同时处理value值
                // 不显示的字段时默认置空
                // console.log('如果是【不通过】时，去掉以下1个字段',shouldKeep)
                if (!shouldKeep) {
                  field.value = ''; // 直接修改原对象
                  if(field.id==='precinct'){
                    field.value = '无';
                  }
                }
                return shouldKeep;
              })
            };
          }
          if(isFailType){
            this.checkErrorList = [];
            // 创建新对象并过滤字段
            return {
              ...instance,
              // 如果是【审核通过】时，去掉以下1个字段
              // errorType:不合格的类型
              // fields: instance.fields.filter(field => !['errorType'].includes(field.id))
              fields:instance?.fields.filter(field => {
                // 过滤掉不需要的字段
                const shouldKeep = !['errorType'].includes(field.id);
                // 如果需要保留，同时处理value值
                // 不显示的字段时默认置空
                if (!shouldKeep) {
                  field.value = ''; // 直接修改原对象
                }
                return shouldKeep;
              })
            };
          }
          if(isPassType){
            // 创建新对象并过滤字段
            return {
              ...instance,
              // 如果是文审未通过时，去掉以下1个字段
              // precinct:片区
              fields:instance?.fields.filter(field => {
                // 过滤掉不需要的字段
                const shouldKeep = !['precinct'].includes(field.id);
                // 如果需要保留，同时处理value值
                // 不显示的字段时默认置空
                if (!shouldKeep) {
                  field.value = ''; // 直接修改原对象
                  if(field.id==='precinct'){
                    field.value = '无';
                  }
                }
                return shouldKeep;
              })
            };
          }
        }
        if(instance?.name?.indexOf('渠道部审核')!==-1){
          const isAudieType = instance?.fields?.some(
              field=>field.id==='auditresult' && (field.value === '同意')
          )
          if(!isAudieType){
            return instance;
          }
          if(isAudieType){
            return {
              ...instance,
              // 如果是【审核同意】时，去掉以下1个字段
              // rejectiontype: 拒绝类型
              // （除拉萨外必填）
              fields: instance?.fields.filter(
                  field => {
                    const shouldKeep = !['rejectiontype'].includes(field.id);
                    // 如果需要保留，同时处理value值
                    // 不显示的字段时默认置空
                    if (!shouldKeep) {
                      field.value = ''; // 直接修改原对象
                    }
                    return shouldKeep;
                  }
              )
            };
          }
        }
        // 移机流程: 如果是 5401 开头的网点编号不需要展示和上传移机申请表字段，否则都需要上传移机申请表
        // 移机流程（移机申请表）（除拉萨外必填）
        const isSiteIdMove = instance?.name?.indexOf('移机')!==-1?instance.fields?.some(
            field => field.id === 'siteid' && (field.value?.substring(0,4) === '5401')
        ):false;
        // 网点录入：注册类型（：自然人、法人）
        const isRegisterType = instance?.fields?.some(
            field=>field.id==='registrationtype' && (field.value === '自然人')
        )
        if(instance?.name?.indexOf('移机')!==-1){
          instance.fields.map((v)=> {
            // 移机的专管员判断表单内的是否前往代销点字段只有拉萨市不能选，其他的地市都可选
            // 是否前往代销点
            if(v.id==='areyougo'){
              if(this.variablesObj?.city.includes('拉萨市')){
                v.value = '是'
                v.readOnly = true;
              }
            }
            // 片区(拉萨市的只显示拉萨的片区，林芝市的只显示林芝片区)
            if (v.id === 'newdistrict') {
              if (this.variablesObj?.city.includes('拉萨')) {
                v.params.customDesign.values = v?.params?.customDesign?.values.filter(item => !item.label.includes('林芝'))
              } else if (this.variablesObj?.city.includes('林芝')) {
                v.params.customDesign.values = v?.params?.customDesign?.values.filter(item => !item.label.includes('拉萨'))
              }
            }
          });
          if(this.variablesObj&&this.variablesObj.city){
            //移机专管员审核流程：如果是拉萨市或者林芝市，需要显示片区，其他地市不需要显示片区
            const new_district =  !this.variablesObj?.city.includes('拉萨')&&!this.variablesObj?.city.includes('林芝');
            if(new_district){
              // 创建新对象并过滤字段
              return {
                ...instance,
                // 如果不是【拉萨市或林芝市】时，去掉以下1个字段
                // newdistrict:新片区
                // fields: instance.fields.filter(field => !['newdistrict'].includes(field.id))
                fields:instance?.fields.filter(field => {
                  // 过滤掉不需要的字段
                  const shouldKeep = !['newdistrict'].includes(field.id);
                  // 如果需要保留，同时处理value值
                  // 不显示的字段时默认置空
                  if (!shouldKeep) {
                    field.value = ''; // 直接修改原对象
                  }
                  return shouldKeep;
                })
              };
            }
          }
        }
        // // 新装机和网点录入流程中的开户行，默认建设银行，不可编辑
        // // 开户银行 bankName
        // instance.fields?.some(
        //     field=>field.id==='bankName'?(field.value === '建设银行'):''
        // )
        // 代销者变更流程：如果网点编号前4位是 5401 开头的，部分图片不用上传且不展示表单内，否则，需要上传图片
        // 代销者变更流程（变更登记表-变更申请承接申请-新业主承诺书-变更代销者资料清单）（除拉萨外必填）
        if(instance.name&&instance?.name?.indexOf('代销者变更')!==-1){
          const isSiteId = instance?.fields?.some(
              field => field.id === 'siteid' && (field.value?.substring(0,4) === '5401')
          );
          // 代销者变更：办理类型（：自办、委托）
          const isNaturalPerson = instance?.fields?.some(
              field => field.id === 'processingType' && (field.value === '自办')
          );
          if (!isNaturalPerson&&!isSiteId) {
            return instance;
          }
          if(isSiteId&&isNaturalPerson){
            return {
              ...instance,
              // 如果是【5401 开头的网点编号】时，去掉以下4个字段
              // 变更登记表-changeRegistrationForm
              // 变更申请承接申请-applicationRegardingChanges
              // 新业主承诺书-undertaking
              // 变更代销者资料清单-materialList
              // （除拉萨外必填）
              fields: instance?.fields.filter(
                  field => {
                    const shouldKeep = !['powerOfAttorney', 'mandatorIdentityImage','changeRegistrationForm', 'applicationRegardingChanges','undertaking','materialList'].includes(field.id);
                    // 如果需要保留，同时处理value值
                    // 不显示的字段时默认置空
                    if (!shouldKeep) {
                      field.value = ''; // 直接修改原对象
                    }
                    return shouldKeep;
                  }
              )
            };
          }
          // 代销者变更流程
          if(isSiteId){
            return {
              ...instance,
              // 如果是【5401 开头的网点编号】时，去掉以下4个字段
              // 变更登记表-changeRegistrationForm
              // 变更申请承接申请-applicationRegardingChanges
              // 新业主承诺书-undertaking
              // 变更代销者资料清单-materialList
              // （除拉萨外必填）
              fields: instance?.fields.filter(
                  field => {
                    const shouldKeep = !['changeRegistrationForm', 'applicationRegardingChanges','undertaking','materialList'].includes(field.id);
                    // 如果需要保留，同时处理value值
                    // 不显示的字段时默认置空
                    if (!shouldKeep) {
                      field.value = ''; // 直接修改原对象
                    }
                    return shouldKeep;
                  }
              )
            };
          }
          // 在表单列表中，进行不同类型，展示或隐藏某字段
          // 隐藏的2个选填字段
          if(isNaturalPerson){
            // 创建新对象并过滤字段
            return {
              ...instance,
              // 如果是【自办】时，去掉以下2个字段
              // powerOfAttorney:委托证明
              // manda torIdentityImage:委托人身份证照片(正反)
              fields: instance?.fields.filter(
                  field => {
                    const shouldKeep = !['powerOfAttorney', 'mandatorIdentityImage'].includes(field.id);
                    // 如果需要保留，同时处理value值
                    // 不显示的字段时默认置空
                    if (!shouldKeep) {
                      field.value = ''; // 直接修改原对象
                    }
                    return shouldKeep;
                  }
              )
            };
          }
        }
        if (!isRegisterType&&!isSiteIdMove) {
          return instance;
        }
        // 移机
        if(isSiteIdMove){
          return {
            ...instance,
            // 如果是【5401 开头的网点编号】时，去掉以下1个字段
            // relocationApplicationForm:移机申请表文件拍照上传
            fields: instance?.fields.filter(
                field => {
                  const shouldKeep = !['relocationApplicationForm'].includes(field.id);
                  // 如果需要保留，同时处理value值
                  // 不显示的字段时默认置空
                  if (!shouldKeep) {
                    field.value = ''; // 直接修改原对象
                  }
                  return shouldKeep;
                }
            )
          };
        }
        if(isRegisterType){
          // 创建新对象并过滤字段
          return {
            ...instance,
            // 如果是【自办】时，去掉以下2个字段
            // company name:公司名称
            // I TIN:纳税人识别号
            // fields: instance.fields.filter(field => !['ITIN', 'companyname'].includes(field.id))
            fields:instance?.fields.filter(field => {
              // 过滤掉不需要的字段
              const shouldKeep = !['ITIN', 'companyname'].includes(field.id);
              // 如果需要保留，同时处理value值
              // 不显示的字段时默认置空
              if (!shouldKeep) {
                field.value = ''; // 直接修改原对象
              }
              return shouldKeep;
            })
          };
        }
        return instance;
      });
    },
    filteredActivities() {
      return this.historyList.map(instance => {
        // 移机流程
        // 移机流程: 如果是 5401 开头的网点编号不需要展示和上传移机申请表字段，否则都需要上传移机申请表
        // 移机流程（移机申请表）（除拉萨外必填）
        if(instance.formInfo?.name?.indexOf('移机')!==-1){
          const isSiteIdMove = instance?.formInfo?.fields?.some(
              field => field.id === 'siteid' && (field.value?.substring(0,4) === '5401')
          );
          if(this.variablesObj&&this.variablesObj.city){
            //移机专管员审核流程：如果是拉萨市或者林芝市，需要显示片区，其他地市不需要显示片区
            const new_district =  !this.variablesObj?.city.includes('拉萨')&&!this.variablesObj?.city.includes('林芝');
            if(new_district){
              return {
                ...instance,
                formInfo: {
                  ...instance?.formInfo,
                  // 如果【不是拉萨市和林芝市】时，去掉以下1个字段
                  // 新片区-newdistrict
                  fields: instance?.formInfo?.fields.filter(
                      field => !['newdistrict'].includes(field.id)
                  )
                }
              };
            }
          }
          if(!isSiteIdMove){
            return instance;
          }
          // 移机
          if(isSiteIdMove){
            return {
              ...instance,
              formInfo: {
                ...instance?.formInfo,
                // 如果是【5401 开头的网点编号】时，去掉以下1个字段
                // 申请表-relocationApplicationForm
                // （除拉萨外必填）
                fields: instance?.formInfo?.fields.filter(
                    field => !['relocationApplicationForm'].includes(field.id)
                )
              }
            };
          }
        }
        // 代销者变更
        if(instance.formInfo?.name?.indexOf('代销者变更')!==-1){
          // 检查代办类型是否是自办
          const isType = instance?.formInfo?.fields?.some(
              field => field.id === 'processingType' && (field.value === '自办')
          );
          // 代销者变更流程：如果网点编号前4位是 5401 开头的，部分图片不用上传且不展示表单内，否则，需要上传图片
          // 代销者变更流程（变更登记表-变更申请承接申请-新业主承诺书-变更代销者资料清单）（除拉萨外必填）
          const isSiteId = instance?.formInfo?.fields?.some(
              field => field.id === 'siteid' && (field.value?.substring(0,4) === '5401')
          );
          if (!isType&&!isSiteId) {
            return instance;
          }
          if(isSiteId&&isType){
            return {
              ...instance,
              formInfo: {
                ...instance?.formInfo,
                // 如果是【5401 开头的网点编号】时，去掉以下4个字段
                // 变更登记表-changeRegistrationForm
                // 变更申请承接申请-applicationRegardingChanges
                // 新业主承诺书-undertaking
                // 变更代销者资料清单-materialList
                // （除拉萨外必填）
                fields: instance?.formInfo?.fields.filter(
                    field => !['powerOfAttorney', 'mandatorIdentityImage','changeRegistrationForm', 'applicationRegardingChanges','undertaking','materialList'].includes(field.id)
                )
              }
            };
          }
          if(isType){
            // 创建新对象并过滤字段
            return {
              ...instance,
              formInfo: {
                ...instance?.formInfo,
                // 如果是【自办】时，去掉以下2个字段
                // powerOfAttorney:委托证明
                // manda torIdentityImage:委托人身份证照片(正反)
                fields: instance?.formInfo?.fields.filter(
                    field => !['powerOfAttorney', 'mandatorIdentityImage'].includes(field.id)
                )
              }
            };
          }

          // 代销者变更流程
          if(isSiteId){
            return {
              ...instance,
              formInfo: {
                ...instance?.formInfo,
                // 如果是【5401 开头的网点编号】时，去掉以下4个字段
                // 变更登记表-changeRegistrationForm
                // 变更申请承接申请-applicationRegardingChanges
                // 新业主承诺书-undertaking
                // 变更代销者资料清单-materialList
                // （除拉萨外必填）
                fields: instance?.formInfo?.fields.filter(
                    field => !['changeRegistrationForm', 'applicationRegardingChanges','undertaking','materialList'].includes(field.id)
                )
              }
            };
          }
        }
        // 新装机
        if(instance.formInfo?.name.indexOf('新装机')!==-1){
          const fields = instance.formInfo.fields;//JSON.parse(JSON.stringify(instance.formInfo.fields));
          const applicantType = fields.find(f => f.id === 'applicanttype')?.value;
          const treatmentType = fields.find(f => f.id === 'treatmentType')?.value;
          // 配置规则
          const rules = {
            // 申请人类型规则
            applicantType: {
              '自然人': {
                show: ['policecertificate'],
                hide: ['uscc', 'aicoc', 'ecr']
              },
              '渠道(烟草渠道)': {
                show: ['policecertificate'],
                hide: ['uscc', 'aicoc', 'ecr']
              },
              '法人': {
                show: ['uscc', 'aicoc', 'ecr'],
                hide: ['policecertificate']
              }
            },
            // 优惠类型规则
            treatmentType: {
              '无': {
                hide: ['diploma', 'retirementimage', 'disabledcertificate']
              },
              '应届大学生': {
                show: ['diploma'],
                hide: ['retirementimage', 'disabledcertificate']
              },
              '退伍军人': {
                show: ['retirementimage'],
                hide: ['diploma', 'disabledcertificate']
              },
              '残障人士': {
                show: ['disabledcertificate'],
                hide: ['diploma', 'retirementimage']
              }
            }
          };

          // 收集需要隐藏的字段
          const fieldsToHide = new Set();

          // 应用申请人类型规则
          const applicantRule = rules.applicantType[applicantType];
          if (applicantRule) {
            applicantRule.hide?.forEach(id => fieldsToHide.add(id));
          }

          // 应用优惠类型规则
          const treatmentRule = rules.treatmentType[treatmentType];
          if (treatmentRule) {
            treatmentRule.hide?.forEach(id => fieldsToHide.add(id));
          }

          // 清空被隐藏字段的值
          fields.forEach(field => {
            if (fieldsToHide.has(field.id)) {
              if (field.files) {
                field.files = [];
              }
              if (field.value !== undefined) {
                field.value = '';
              }
            }
          });

          // 过滤字段
          const filteredFields = fields.filter(field => !fieldsToHide.has(field.id));

          return {
            ...instance,
            formInfo: {
              ...instance.formInfo,
              fields: filteredFields
            }
          };
        }
        if(instance?.formInfo?.name?.indexOf('文审')!==-1){

          //阳光征召资料审核流程：如果是拉萨市的地址，需要显示片区，否则不需要显示片区
          const isFailType = instance?.formInfo?.fields?.some(
              field=>field.id==='documentReview' && (field.value === '通过')
          )
          if(!isFailType){
            return instance;
          }
          // if(isCityType&&isFailType){
          //   return {
          //     ...instance,
          //     formInfo: {
          //       ...instance?.formInfo,
          //       // 如果是【非拉萨市,且不同意】时，去掉以下1个字段
          //       // precinct:片区
          //       // errorType:错误类型
          //       fields: instance?.formInfo?.fields.filter(
          //           field => !['precinct','errorType'].includes(field.id)
          //       )
          //     }
          //   };
          // }
          // if(isCityType){
          //   // 创建新对象并过滤字段
          //   return {
          //     ...instance,
          //     formInfo: {
          //       ...instance?.formInfo,
          //       // 如果是【非拉萨市】时，去掉以下1个字段
          //       // precinct:片区
          //       fields: instance?.formInfo?.fields.filter(
          //           field => !['precinct'].includes(field.id)
          //       )
          //     }
          //   };
          // }
          if(isFailType){
            // 创建新对象并过滤字段
            return {
              ...instance,
              formInfo: {
                ...instance?.formInfo,
                // 如果是【审核通过】时，去掉以下1个字段
                // errorType:不合格的类型
                fields: instance?.formInfo?.fields.filter(
                    field => !['errorType'].includes(field.id)
                )
              }
            };
          }
        }
        // 新装机现场验收 渠道 部 审核
        if(instance?.formInfo?.name?.indexOf('渠道部审核')!==-1){
          const isAudieType = instance?.formInfo?.fields?.some(
              field=>field.id==='auditresult' && (field.value === '同意')
          )
          if(!isAudieType){
            return instance;
          }
          if(isAudieType){
            // 创建新对象并过滤字段
            return {
              ...instance,
              formInfo: {
                ...instance?.formInfo,
                // 如果是【审核同意】时，去掉以下1个字段
                // rejectiontype: 拒绝类型
                fields: instance?.formInfo?.fields.filter(
                    field => !['rejectiontype'].includes(field.id)
                )
              }
            };
          }
        }
        // 一般巡检 流程
        if (instance?.formInfo?.name?.indexOf('一般巡检') !== -1) {
          const fields = instance?.formInfo?.fields;
          // 定义字段隐藏规则：上传字段id -> 控制字段id
          const hideRules = {
            'shootsConsignmentCertificate':'isConsignmentCertificate',
            'shootCertificate': 'certificateIsExist',
            'certificateIsValidity':'certificateIsExist',
            'shootTitle': 'titleIsExist',
            'storefrontstyle': 'titleIsExist',
            'shootAnnouncement': 'announcementIsExist',
            'shootfireProtection': 'fireProtectionIsExist',
            'shootwelfareLotterySecurityArea': 'welfareLotteryIsFull',
            'shootwelfareLotteryIsFront':'welfareLotteryIsScratch',
            'shootWarning':'warningIsExist',
            'shootCreditSale': 'creditSaleIsExist',
            'shootVulgar': 'vulgarIsExist',
            'isFlammableImage':'isFlammable',
            'isChargingImage':'isCharging',
            'isElectricalAppliancesImage':'isElectricalAppliances',
            'isCameraUnification':'isCamera',
            'isCameraImage':'isCamera',
            'isTidyImage':'isTidy'
          };

          // 定义特殊规则（某些字段的隐藏条件不是"否"）
          const specialRules = {
            'shootsConsignmentCertificate': {
              controlField: 'isConsignmentCertificate',
              hideWhenValue: '无'  // 值为"无"时隐藏
            },
            'shootwelfareLotterySecurityArea': {
              controlField: 'welfareLotteryIsFull',
              hideWhenValue: '是'  // 值为"是"时隐藏
            },
            'shootwelfareLotteryIsFront': {
              controlField: 'welfareLotteryIsScratch',
              hideWhenValue: '是'  // 值为"是"时隐藏
            }
          };

          // 构建字段映射，提高查找效率
          const fieldMap = new Map();
          fields.forEach(field => {
            fieldMap.set(field.id, field);
          });

          // 收集需要隐藏的字段
          const fieldsToHide = new Set();

          // 处理每个被控字段
          Object.entries(hideRules).forEach(([controlledId, controlId]) => {
            const controlField = fieldMap.get(controlId);
            if (controlField) {
              let shouldHide = false;

              // 检查是否有特殊规则
              if (specialRules[controlledId]) {
                const rule = specialRules[controlledId];
                shouldHide = controlField.value === rule.hideWhenValue;
              } else {
                // 默认规则：值为"否"时隐藏
                shouldHide = controlField.value === '否';
              }

              if (shouldHide) {
                fieldsToHide.add(controlledId);
                // 清空被控字段的值
                const controlledField = fieldMap.get(controlledId);
                if (controlledField) {
                  controlledField.value = '';
                  if (controlledField.files) {
                    controlledField.files = [];
                  }
                }
              }
            }
          });

          // 过滤掉需要隐藏的字段
          const filteredFields = fields.filter(field => !fieldsToHide.has(field.id));

          return {
            ...instance,
            formInfo: {
              ...instance.formInfo,
              fields: filteredFields
            }
          };
        }
        return instance;
      });
    },
    firstItemValue() {
      this.formFields.map((v) => {
        // 获取如果是复选框，接口勘察人员列表从接口返回取
        if (v.params.customDesign) {
          if (v.params.customDesign.type === 'select') {
            // 复选框
            if(v.params.customDesign.multiple){
              // 单独查询专管员列表
              if(v.id==='surveyor'){
                dynamicDataListSpecialManager({}).then((res)=>{
                  if(res){
                    if(!res.data){
                      return false;
                    }
                    if(res.data){
                      v.checkName = res.data;
                      this.checkName = res.data;
                    }
                  }
                });
              }
            }else{
              // 单选下拉数据
              if(v.id==='surveyor'){
                dynamicDataListSpecialManager({}).then((res)=>{
                  if(res){
                    if(!res.data){
                      return false;
                    }
                    if(res.data){
                      v.params.customDesign.values = res.data;
                    }
                  }
                });
              }
            }
          }
        }
      });
      return this.formFields[0]?.id==='siteid'?this.formFields[0]?.value:null;
      // return this.formFields[0]?.value;
    },
    // rulesConfig() {
    //   return {
    //     name: [
    //       { required: true, message: `请输入姓名` },
    //       { validator: this.validateName, message: '姓名格式不正确' },
    //     ],
    //     phone: [
    //       { required: true, message: '请输入手机号' },
    //       { validator: this.validatePhone, message: '手机号格式不正确' }
    //     ],
    //     identity: [
    //       { required: true, message: '请输入身份证号' },
    //       { validator: this.validateIdCard, message: '身份证号格式不正确' }
    //     ]
    //   }
    // }
  },
  watch: {
    value(val) {
      this.showPopup = val;
    },
    showPopup(val) {
      this.$emit('input', val);
    },
    siteIdObj: {
      handler(newVal) {
        if(newVal&&newVal.branchId){
          this.formFields.map((v)=>{
            if(v.id==='siteid'){
              v.value = newVal.branchId+'';
            }
          });
          this.performSearch(newVal.branchId);
        }
      },
      immediate: true, // 立即执行一次
      deep: true,      // 如果是对象/数组，深度监听
    },
    newSiteId(newVal){
      if(this.formFields[0]?.id==='siteid'){
        if(newVal){
          this.formFields[0].value = newVal;
        }
      }
    },
    firstItemValue(newVal, oldVal) {
      if (!newVal || !oldVal) return;
      if (newVal !== oldVal) {
        // 输入八位网点编号时，执行接口，回显数据
        if(newVal.length===8){
          this.performSearch(newVal);
        }else{
          if(this.listDataInfo.length>0){
            this.userUpdateForm[0].fields.map((v)=>{
              if(v.id==='siteid'&&v.value){

              }else{
                if(v.id==='name'){
                  //   销售员姓名
                  v.value = '';
                  v.readOnly = false;
                }else if(v.id==='previousName'){
                  //   销售员姓名
                  v.value = '';
                  v.readOnly = false;
                }else if(v.id==='distributorsname'){
                  //   销售员姓名
                  v.value = '';
                  v.readOnly = false;
                }else if(v.id==='distributorname'){
                  //   销售员姓名
                  v.value = '';
                  v.readOnly = false;
                }else if(v.id==='distributorsphone'){
                  //   销售员手机号
                  v.value = '';
                  v.readOnly = false;
                }else if(v.id==='distributorphone'){
                  //   销售员手机号
                  v.value = '';
                  v.readOnly = false;
                }else if(v.id==='phone'){
                  //   销售员手机号
                  v.value = '';
                  v.readOnly = false;
                }else if(v.id==='previousphone'){
                  //   销售员手机号
                  v.value = '';
                  v.readOnly = false;
                }else if(v.id==='city'){
                  // 地市和回显数据
                  // 地市
                  v.value = '';
                  v.readOnly = false;
                }else if(v.id==='oldAddress'){
                  // 原始地址
                  v.value = '';
                  v.readOnly = false;
                }else if(v.id==='address'){
                  // 原始地址
                  v.value = '';
                  v.readOnly = false;
                }else if(v.id==='area'){
                  // 地址
                  v.value = '';
                  v.readOnly = false;
                }else if(v.id==='address'){
                  // 原始地址
                  v.value = '';
                  v.readOnly = false;
                }else if(v.id==='name'){
                  //   原代销者姓名
                  v.value = '';
                  v.readOnly = false;
                }else if(v.id==='previousName'){
                  //   原代销者姓名
                  v.value = '';
                  v.readOnly = false;
                }else if(v.id==='distributorsname'){
                  //   原代销者姓名
                  v.value = '';
                  v.readOnly = false;
                }else if(v.id==='distributorname'){
                  //   原代销者姓名
                  v.value = '';
                  v.readOnly = false;
                }else if(v.id==='distributorsphone'){
                  //   原代销者手机号
                  v.value = '';
                  v.readOnly = false;
                }else if(v.id==='distributorphone'){
                  //   原代销者手机号
                  v.value = '';
                  v.readOnly = false;
                }else if(v.id==='phone'){
                  //   原代销者手机号
                  v.value = '';
                  v.readOnly = false;
                }else if(v.id==='previousphone'){
                  //   原代销者手机号
                  v.value = '';
                  v.readOnly = false;
                }else if(v.id==='identity'){
                  //   原代销者身份证号
                  v.value = '';
                  v.readOnly = false;
                }else if(v.id==='previousidentity'){
                  //   原代销者身份证号
                  v.value = '';
                  v.readOnly = false;
                }else if(v.id==='distributorsidentity'){
                  //   原代销者身份证号
                  v.value = '';
                  v.readOnly = false;
                }else if(v.id==='managementkind'){
                  // 经营类型
                  v.value = '';
                  v.readOnly = false;
                }else if(v.id==='management_kind'){
                  // 经营类型
                  v.value = '';
                  v.readOnly = false;
                }
              }
            });
          }
        }
      }
    },
  },
  created() {
    // this.$nextTick(() => {
    //   let uploadId2 = document.getElementById('locationImage_1')
    //   if(uploadId2){
    //     console.log(uploadId2.children[0])
    //     console.log(uploadId2.children[0].children[0])
    //     console.log(uploadId2.children[0].children[1])
    //     console.log('1100011')
    //     uploadId2.children[0].children[1].setAttribute('capture', 'camera');
    //   }
    // });
  },
  methods: {
    getCheck(item){
      this.resultData = {};
      this.resultData_van = {};
      this.explainList = [];
      inspection_explain_details({
        id:item.id
      }).then((res)=>{
        if(res){
          let redData = res.data;
          if(redData.code===200){
            if(redData.data){
              if(redData.data.explain==='无'){
                this.resultData_van = redData.data;
                // this.$toast(`${item.name} 暂无说明`);
              }else{
                this.explainList = redData.data.explain.split('|');
                this.resultData = redData.data;
              }
            }else {
              this.resultData_van = {
                name:item.name,
                id:item.id,
                fieldId:item.id
              };
              // this.$toast(`${item.name} 暂无说明`);
              return false;
            }
          }
          // {
          //   "code": 200,
          //     "msg": "操作成功",
          //     "data": {
          //   "explain": "1、福彩专营:仅经营福彩|2、福体专营:同时经营福彩和体彩|3、福彩兼营:经营福彩与其他行业|4、福体兼营:经营福彩体彩与其他行业",
          //       "id": 2,
          //       "title": "经营模式",
          //       "fieldId": "businessModel"
          // }
          // }
          //
        }
      })
      // this.$nextTick(()=>{
      //   this.userUpdateForm[0].fields.map((v)=>{
      //     if(item.id===v.id){
      //       v.checked = true;
      //       console.log(v.checked)
      //     }
      //   })
      // })
    },
    async handleCopy() {
      try {
        // 尝试使用现代 Clipboard API
        if (navigator.clipboard) {
          await navigator.clipboard.writeText(`${this.variablesObj.name} ${this.variablesObj.identity}`);
          this.$toast.success('复制成功!');
        } else {
          // 降级方案：使用 document.execCommand
          this.fallbackCopyText(`${this.variablesObj.name} ${this.variablesObj.identity}`);
        }
      } catch (err) {
        console.error('复制失败:', err);
        this.$toast.fail('复制失败!');
      } finally {
        console.log('555555')
      }
    },

    fallbackCopyText(text) {
      console.log('降级')
      const textarea = document.createElement('textarea');
      textarea.value = text;
      // 防止页面滚动
      textarea.style.position = 'fixed';
      textarea.style.top = 0;
      textarea.style.left = 0;
      textarea.style.opacity = 0;

      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();

      try {
        const successful = document.execCommand('copy');
        if(successful){
          this.$toast.success('复制成功!');
          console.log('11111111')
        }else{
          this.$toast.fail('复制失败!');
          console.log('222222222')
        }
      } catch (err) {
        console.error('降级复制失败:', err);
        this.$toast.fail('复制失败!');
      }

      document.body.removeChild(textarea);
    },
    // 打分时...
    onChange(index) {
      this.formFields[index].socre = this.formFields[index].value*2;
      this.formFields[index].scoreValue = this.formFields[index].value;
    },
    onValueChange(){
      this.$toast('点击提交按钮后，请勿重复操作数据！');
    },
    // locationImage
    // 上传照片 oss
    beforeUploadImg1(file) {
      if (
          ["image/png","image/jpg", "image/jpeg",].indexOf(file.type) === -1     //控制格式
      ) {
        this.$toast("请上传正确的图片格式");
        return false;
      }
      let fileSize = file.size / 1024 / 1024 < 500;   //控制大小  修改50的值即可
      if (!fileSize) {
        this.$toast("图片大小不能超过500MB");
        return false;
      }
      this.isShowUploadImg1 = false;
      this.imgForm1.showVideoPath = URL.createObjectURL(file);
    },
    // //进度条
    // uploadImgProcess1(event, file, fileList) {    //注意在data中添加对应的变量名
    //   this.imgFlag1 = true;
    //   this.imgUploadPercent1 = file.percentage.toFixed(0) * 1;
    // },
    handleSuccess(response, file, fileList, index,item) {
      this.loading = true;
      this.isShowUploadImg1 = true;
      this.imgFlag1 = false;
      this.imgUploadPercent1 = 0;
      //后台上传数据
      if (response.code === 200) {
        if(response.data){
          this.loading = false;
          let arr = []
          fileList.map((v)=>{
            if(v.response){
              arr.push(v.response.data.url)
            }
          });
          // console.log('fileList',fileList)
          this.formFields.map((v,k)=>{
            if(v.id===item.id){
              this.formFields[k].files = fileList;
              this.formFields[k].value = arr.join(',');
            }
          });
        }
      } else {
        this.$toast(response.msg);
        return false;
      }
    },
    handleExceed() {
      this.$toast(`最多只能上传 2 张图片`);
    },
    handleRemove(file, fileList, index) {
      let arr = []
      fileList.map((v)=>{
        if(v.response){
          arr.push(v.response.data.url);
        }
      });
      this.formFields[index].files = fileList;
      this.formFields[index].value = arr.join(',');
    },
    onIsInServiceReturn(){
      return new Promise(resolve => {
        // 后端接口返回
        processIsinservice({
          siteId:this.siteId,
          processDefinitionName:this.flowNameObj.processDefinitionName
        }).then((resData) => {
          let res = resData.data;
          if (res) {
            if (res.code && res.code === 200) {
              resolve(res.data);
            } else {
              if (res.msg) {
                this.$toast(res.msg);
              }
            }
          }
        });
      });
    },
    onIsMobileBindReturn(data){
      return new Promise(resolve => {
        // 后端接口返回
        processIsBind(data).then((resData) => {
          let res = resData.data;
          if (res) {
            if (res.code && res.code === 200) {
              resolve(res.data);
            } else {
              if (res.msg) {
                this.$toast(res.msg);
              }
            }
          }
        });
      });
    },
    // 输入8位数网点编号时，触发此方法，查询关于网点信息
    performSearch(siteId) {
      this.siteId = siteId;
      let processDefinitionName = '';
      if (this.returnObj.processDefinitionName) {
        processDefinitionName = this.returnObj.processDefinitionName;
      } else if (this.siteIdObj.processDefinitionName) {
        processDefinitionName = this.siteIdObj.processDefinitionName;
      } else if (this.flowNameObj.processDefinitionName) {
        processDefinitionName = this.flowNameObj.processDefinitionName;
      }
      if(siteId&&processDefinitionName){
        this.innerLoading = true;
        processIsinservice({
          siteId:siteId,
          processDefinitionName:processDefinitionName
        }).then((res)=>{
          if(res){
            if (res.data) {
              if (res.data.code === 200) {
                //为true时，不能创建，为false时可以创建
                if(!res.data.data){
                  if(getLocalItem('local_role')&&getLocalItem('local_role')==='销售员'){
                    // 查销售员的网点信息
                    salespersonInfoList({}).then((res)=>{
                      if(res){
                        if(res.data){
                          if(res.data.code===200){
                            if(res.data.rows.length>0){
                              this.listDataInfo = res.data.rows;
                              // // 代销者信息
                              // if(res.data.rows[0].branchInfo){
                              //   this.agentInfo = res.data.rows[0].branchInfo;
                              //   this.siteItem = res.data.rows[0].branchInfo;
                              // }
                              // // 销售员信息
                              // this.salesObj = res.data.rows[0];
                              this.formFields.map((v)=>{
                                if(v.id==='name'){
                                  //   销售员姓名
                                  v.value = res.data.rows[0].name;
                                  v.readOnly = true;
                                }else if(v.id==='previousName'){
                                  //   销售员姓名
                                  v.value = res.data.rows[0].name;
                                  v.readOnly = true;
                                }else if(v.id==='distributorsname'){
                                  //   销售员姓名
                                  v.value = res.data.rows[0].name;
                                  v.readOnly = true;
                                }else if(v.id==='distributorname'){
                                  //   销售员姓名
                                  v.value = res.data.rows[0].name;
                                  v.readOnly = true;
                                }else if(v.id==='distributorsphone'){
                                  //   销售员手机号
                                  v.value = res.data.rows[0].contact;
                                  v.readOnly = true;
                                }else if(v.id==='distributorphone'){
                                  //   销售员手机号
                                  v.value = res.data.rows[0].contact;
                                  v.readOnly = true;
                                }else if(v.id==='phone'){
                                  //   销售员手机号
                                  v.value = res.data.rows[0].contact;
                                  v.readOnly = true;
                                }else if(v.id==='previousphone'){
                                  //   销售员手机号
                                  v.value = res.data.rows[0].contact;
                                  v.readOnly = true;
                                }else if(v.id==='city'){
                                  // 地市和回显数据
                                  // 地市
                                  if(res.data.rows[0].branchInfo){
                                    // v.value = res.data.rows[0].branchInfo.city;
                                    // v.readOnly = true;
                                    // 销售员的设备保修流程
                                    if(res.data.rows[0].branchInfo.area!==''||res.data.rows[0].area&&res.data.rows[0].branchInfo.area!==null){
                                      v.value = `${res.data.rows[0].branchInfo.city}-${res.data.rows[0].branchInfo.area}`;
                                      // 移机的地市单独处理
                                      if(v.params.customDesign.type==='radio'){
                                        if(this.formDefine&&this.formDefine.name.indexOf('移机')!==-1){
                                          if(res.data.rows[0].branchInfo.city.indexOf('拉萨')!==-1){
                                            v.params.customDesign.values.map((m)=>{
                                              m.disabled = true;
                                              // m.disabled = m.label.indexOf('拉萨') === -1;
                                            });
                                          }else{
                                            v.params.customDesign.values.map((m)=>{
                                              m.disabled = true;
                                            });
                                          }
                                        }else{
                                          v.readOnly = true;
                                        }
                                      }else{
                                        v.readOnly = true;
                                      }
                                      // v.readOnly = true;
                                      // this.userUpdateForm[0].fields[k].readOnly = true;
                                    }else{
                                      // 地市
                                      v.value = res.data.rows[0].branchInfo.city;
                                      if(v.params.customDesign.type==='radio'){
                                        if(this.formDefine&&this.formDefine.name.indexOf('移机')!==-1){
                                          if(res.data.rows[0].branchInfo.city.indexOf('拉萨')!==-1){
                                            v.params.customDesign.values.map((m)=>{
                                              m.disabled = true;
                                              // m.disabled = m.label.indexOf('拉萨') === -1;
                                            });
                                          }else{
                                            v.params.customDesign.values.map((m)=>{
                                              m.disabled = true;
                                            });
                                          }
                                        }else{
                                          v.readOnly = true;
                                        }
                                      }else{
                                        v.readOnly = true;
                                      }
                                    }
                                  }
                                }else if(v.id==='oldAddress'){
                                  // 原始地址
                                  if(res.data.rows[0].branchInfo) {
                                    v.value = res.data.rows[0].branchInfo.address;
                                    v.readOnly = true;
                                  }
                                }else if(v.id==='address'){
                                  // 原始地址
                                  if(res.data.rows[0].branchInfo) {
                                    v.value = res.data.rows[0].branchInfo.address;
                                    v.readOnly = true;
                                  }
                                }else if(v.id==='area'){
                                  // 详细地址（网点录入）
                                  if(res.data.rows[0].branchInfo) {
                                    v.value = res.data.rows[0].branchInfo.address;
                                    v.readOnly = true;
                                  }
                                }
                              });
                            }
                          }else{
                            this.$toast.fail(res.data.msg);
                          }
                          this.innerLoading = false;
                        }
                      }
                    });
                  }else{
                    // 查代销者的网点信息
                    this.getSiteIdQuery(siteId,processDefinitionName);
                  }
                }else{
                  this.innerLoading = false;
                  this.$toast('当前网点正在流程中，不可重复操作！');
                  return false;
                }
              }else{
                this.$toast(res.data.msg);
              }
            }
          }
        });
      }
    },
    getSiteIdQuery(siteId,processDefinitionName){
      branchInfoList2({
        pageNum:1,
        pageSize:10,
        branchId:siteId
      }).then((res) => {
        if (res) {
          if (res.data) {
            if (res.data.code === 200) {
              /*{
                  "branchId": 54010888,
                  "businessType": "1",
                  "businessStatus": 1,
                  "closureReason": "",
                  "agentInfo": {
                      "createDept": 103,
                      "createBy": 1,
                      "createTime": "2025-05-06 03:07:50",
                      "updateBy": 1,
                      "updateTime": "2025-06-04 14:10:29",
                      "userId": "1919469099591692290",
                      "city": "北京市",
                      "agentName": "程贺",
                      "gender": "2",
                      "contact": "17610836668",
                      "idCard": "231084198308160316",
                      "deptId": 103,
                      "bankName": "中国建设银行",
                      "bankBranch": "北京",
                      "bankCardNumber": "4367421144820151666",
                      "bankCommit": 1,
                      "branchInfo": null
                  },
                  "salespersonInfos": [
                      {
                          "createDept": 103,
                          "createBy": 1,
                          "createTime": "2025-05-06 10:25:50",
                          "updateBy": null,
                          "updateTime": "2025-05-06 10:25:50",
                          "userId": "1919579324905238530",
                          "city": "西藏自治区/拉萨市",
                          "name": "陈雨欣",
                          "gender": "1",
                          "age": "33",
                          "contact": "15210826875",
                          "jobCertificate": null,
                          "registrationDate": null,
                          "deptId": 103,
                          "reviewStatus": 1
                      },
                      {
                          "createDept": 103,
                          "createBy": 1,
                          "createTime": "2025-05-06 10:30:10",
                          "updateBy": null,
                          "updateTime": "2025-05-06 10:30:10",
                          "userId": "1919580416531574786",
                          "city": "西藏自治区/拉萨市",
                          "name": "姚洋",
                          "gender": "0",
                          "age": "32",
                          "contact": "18600921552",
                          "jobCertificate": null,
                          "registrationDate": null,
                          "deptId": 103,
                          "reviewStatus": 0
                      },
                      {
                          "createDept": 103,
                          "createBy": 1,
                          "createTime": "2025-05-16 22:50:56",
                          "updateBy": null,
                          "updateTime": "2025-05-16 22:50:56",
                          "userId": "1923390716042674177",
                          "city": "西藏自治区/拉萨市",
                          "name": "程销售",
                          "gender": "0",
                          "age": "43",
                          "contact": "13910888654",
                          "jobCertificate": null,
                          "registrationDate": null,
                          "deptId": 103,
                          "reviewStatus": 1
                      }
                  ],
                  "branchType": "2",
                  "branchLevel": "一级",
                  "province": "北京市",
                  "city": "北京市",
                  "district": "朝阳区",
                  "townShip": "太阳宫乡",
                  "address": "测试地址",
                  "storefrontPhoto": "1930145101589946369",
                  "storefrontPhotoUrl": "http://dcom.unlto.com/2025/06/04/14705e599c8a492e9b0bead10ff0cfb3.jpg",
                  "storefrontAddress": "北京市朝阳区太阳宫乡太阳宫体育休闲公园",
                  "updateTime": "2025-06-04 14:10:29",
                  "deptId": 103,
                  "companyName": null,
                  "taxpayerId": null,
                  "agentCertificate": "1927267299304898561",
                  "agentCertificateCode": null,
                  "agentCertificateUrl": "http://dcom.unlto.com/2025/05/27/87513a54b2684c9ebfd047eb6c674747.jpg",
                  "ticketPhoto": "1928374276233404417",
                  "ticketPhotoUrl": "http://dcom.unlto.com/2025/05/30/7f557941745e468896d324af0e694b17.jpg",
                  "registrationDate": null,
                  "longitude": 116.4484634399414,
                  "latitude": 39.98253631591797,
                  "storefrontCommit": 1,
                  "storefrontError": 1,
                  "registrationType": "1"
              }*/
              if(res.data.rows&&res.data.rows.length>0){
                this.siteIdInfoObj = res.data.rows[0];

                // 网点录入  查重
                if(processDefinitionName.indexOf('网点录入')!==-1){
                  this.$toast('该网点编号已存在，不可以重录录入！');
                  this.innerLoading = false;
                }else if(processDefinitionName.indexOf('新装机')!==-1){
                  this.$toast('该网点编号已存在，不可以重复使用！');
                  this.innerLoading = false;
                }else{
                  this.listDataInfo = res.data.rows;
                  if(res.data.rows[0].agentInfo.contact===null||res.data.rows[0].agentInfo.contact===''){
                    this.innerLoading = false;
                    // 提交按钮不可点击
                    this.disabledSubmitFlag = true;
                    this.$toast('该网点已撤机，不能参与流程变更！');
                    return false;
                  }
                  this.disabledSubmitFlag = false;
                  this.formFields.map((v)=>{
                    // res.data.rows[0].businessType==='1'?'专营':'兼营'
                    // res.data.rows[0].branchType==='1'?'福彩':'福体'
                    // 地市和回显数据
                    if(v.id==='city'){
                      if(res.data.rows[0].area&&res.data.rows[0].area!==''){
                        v.value = `${res.data.rows[0].city}-${res.data.rows[0].area}`;
                        // 移机的地市单独处理
                        if(v.params.customDesign.type==='radio'){
                          if(this.formDefine&&this.formDefine.name.indexOf('移机')!==-1){
                            if(res.data.rows[0].city.indexOf('拉萨')!==-1){
                              v.params.customDesign.values.map((m)=>{
                                m.disabled = true;
                                // m.disabled = m.label.indexOf('拉萨') === -1;
                              });
                            }else{
                              v.params.customDesign.values.map((m)=>{
                                m.disabled = true;
                              });
                            }
                          }else{
                            v.readOnly = true;
                          }
                        }else{
                          v.readOnly = true;
                        }
                        // v.readOnly = true;
                        // this.userUpdateForm[0].fields[k].readOnly = true;
                      }else{
                        // 地市
                        v.value = res.data.rows[0].city;
                        if(v.params.customDesign.type==='radio'){
                          if(this.formDefine&&this.formDefine.name.indexOf('移机')!==-1){
                            if(res.data.rows[0].city.indexOf('拉萨')!==-1){
                              v.params.customDesign.values.map((m)=>{
                                m.disabled = true;
                                // m.disabled = m.label.indexOf('拉萨') === -1;
                              });
                            }else{
                              v.params.customDesign.values.map((m)=>{
                                m.disabled = true;
                              });
                            }
                          }else{
                            v.readOnly = true;
                          }
                        }else{
                          v.readOnly = true;
                        }
                      }
                    }else if(v.id==='oldAddress'){
                      // 原始地址
                      v.value = res.data.rows[0].address;
                      v.readOnly = true;
                      // this.userUpdateForm[0].fields[k].readOnly = true;
                    }else if(v.id==='address'){
                      // 原始地址
                      v.value = res.data.rows[0].address;
                      v.readOnly = true;
                      // this.userUpdateForm[0].fields[k].readOnly = true;
                    }else if(v.id==='name'){
                      //   原代销者姓名
                      v.value = res.data.rows[0].agentInfo.agentName;
                      v.readOnly = true;
                    }else if(v.id==='previousName'){
                      //   原代销者姓名
                      v.value = res.data.rows[0].agentInfo.agentName;
                      v.readOnly = true;
                    }else if(v.id==='distributorsname'){
                      //   原代销者姓名
                      v.value = res.data.rows[0].agentInfo.agentName;
                      v.readOnly = true;
                    }else if(v.id==='distributorname'){
                      //   原代销者姓名
                      v.value = res.data.rows[0].agentInfo.agentName;
                      v.readOnly = true;
                    }else if(v.id==='distributorsphone'){
                      //   原代销者手机号
                      v.value = res.data.rows[0].agentInfo.contact;
                      v.readOnly = true;
                    }else if(v.id==='distributorphone'){
                      //   原代销者手机号
                      v.value = res.data.rows[0].agentInfo.contact;
                      v.readOnly = true;
                    }else if(v.id==='phone'){
                      //   原代销者手机号
                      v.value = res.data.rows[0].agentInfo.contact;
                      v.readOnly = true;
                    }else if(v.id==='previousphone'){
                      //   原代销者手机号
                      v.value = res.data.rows[0].agentInfo.contact;
                      v.readOnly = true;
                    }else if(v.id==='identity'){
                      //   原代销者身份证号
                      v.value = res.data.rows[0].agentInfo.idCard;
                      v.readOnly = true;
                    }else if(v.id==='previousidentity'){
                      //   原代销者身份证号
                      v.value = res.data.rows[0].agentInfo.idCard;
                      v.readOnly = true;
                    }else if(v.id==='distributorsidentity'){
                      //   原代销者身份证号
                      v.value = res.data.rows[0].agentInfo.idCard;
                      v.readOnly = true;
                    }else if(v.id==='managementkind'){
                      // 经营类型
                      let a = res.data.rows[0].branchType==='1'?'福彩':'福体';
                      let b = res.data.rows[0].businessType==='1'?'专营':'兼营';
                      v.value = a+b;
                      v.readOnly = true;
                    }else if(v.id==='management_kind'){
                      // 经营类型
                      let a = res.data.rows[0].branchType==='1'?'福彩':'福体';
                      let b = res.data.rows[0].businessType==='1'?'专营':'兼营';
                      v.value = a+b;
                      v.readOnly = true;
                    }else if(v.id==='new_management_kind'){
                      //新经营类型变更（原始的经营类型值在新的经营类型选项中禁止选中）
                      let a = res.data.rows[0].branchType==='1'?'福彩':'福体';
                      let b = res.data.rows[0].businessType==='1'?'专营':'兼营';
                      if(v.params.customDesign.type==='radio'){
                        if(this.formDefine&&this.formDefine.name.indexOf('经营类型')!==-1){
                          v.params.customDesign.values.map((m)=>{
                            m.disabled = m.label===(a+b);
                          });
                        }
                      }
                    }
                  });
                }
              }else{
                // 网点录入  查重
                if(processDefinitionName.indexOf('网点录入')!==-1){
                  this.$toast('该网点编号可以使用！');
                  this.innerLoading = false;
                }else if(processDefinitionName.indexOf('新装机')!==-1){
                  this.$toast('该网点编号可以使用！');
                  this.innerLoading = false;
                } else{
                  this.$toast(`${siteId}网点暂无数据！`);
                  // 提交按钮不可点击
                  this.disabledSubmitFlag = true;
                }
              }
            }else{
              this.$toast(res.data.msg);
            }
            this.innerLoading = false;
          }
        }
      });
    },
    async getFixedTwoLatLon(index){
      if(this.variablesObj&&this.variablesObj.hiddenCoordinates){
        const cordResult = await this.fixedLatLon({
          coord:this.variablesObj.hiddenCoordinates,
          coord1:this.formFields[index].value
        });
        if(!cordResult.state){
          this.$toast(cordResult.explain);
          return false;
        }
      }
    },
    fixedLatLon(data){
      return new Promise(resolve => {
        // 后端接口返回
        processIsCord(data).then((resData) => {
          let res = resData.data;
          if (res) {
            if (res.code && res.code === 200) {
              resolve(res.data);
            } else {
              if (res.msg) {
                this.$toast(res.msg);
              }
            }
          }
        });
      });
    },
    getFixedLocal(latitude,longitude,index,type){
      let params = {
        latitude: latitude,
        longitude: longitude,
      }
      // // 巡检时，增加一个网点编号的字段
      // if(type==='fixed-site'){
      //   params.branchId = this.siteIdObj.branchId?this.siteIdObj.branchId:'';
      // }
      if(type==='fixed-site'){
        // true：本人在附近
        // true:可以 false:不可以
        this.formFields[index].value = latitude+','+longitude;
      }
      branchInfoJudgeDistance(params).then((res) => {
        if(res){
          if(res.data){
            if(res.data.data){
              if(type==='fixed-site') {
                // // true：本人在附近
                // // true:可以 false:不可以
                // this.formFields[index].value = latitude + ',' + longitude;
              } else {
                // true 是可以申请，200米内没有网点
                this.formFields[index].value = '否';
                this.formFields[index].valueMsg = res.data.msg;
                this.formFields[index].valuesFlags = true;
              }
            }else{
              if(type==='fixed-site'){
                // //false ：是 是本人不在网点附近
                // Dialog.alert({
                //   title: '提示',
                //   message: `
                //     <div class="innerDialog">
                //       <div style="text-align: left;">您当前的位置不在网点附近，请前往门店进行巡检。</div>
                //     </div>`,
                //   confirmButtonText: '确定',
                //   theme: 'round-button',
                // }).then(() => {
                //   console.log('位置偏移过大')
                //   // this.showPopup = false;
                //   this.getApiDel();
                // });
              }else {
                // false 是 可以不申请，200米内有网点
                this.formFields[index].value = '是';
                this.formFields[index].valueMsg = res.data.msg;
                this.formFields[index].valuesFlags = false;
              }
            }
          }
        }
      });
    },
    // 新建流程未提交的流程，关闭页面执行删除操作
    // resetForm(){
    //   // 有历史数据的，不删流程，只有新创建的流程删
    //   if(this.content==='del'){
    //     if (!this.isManClose) {
    //       this.innerLoading = true;
    //       this.getApiDel();
    //     }
    //   }else{
    //     this.showPopup = false;
    //     this.innerLoading = false;
    //   }
    // },
    // 新建流程未提交的流程，关闭页面执行删除操作
    cancel() {
      // 有历史数据的，不删流程，只有新创建的流程删
      if(this.content==='del'){
        this.innerLoading = true;
        // this.isManClose = true;
        this.getApiDel();
      }else{
        this.showPopup = false;
        this.innerLoading = false;
      }
    },
    // 新建流程未提交的流程，关闭页面执行删除操作
    getApiDel() {
      let processInstanceId = '';
      // 巡检的数据多一层processStartOutput
      if(this.returnObj.processStartOutput){
        processInstanceId = this.returnObj.processStartOutput.processInstanceId ? this.returnObj.processStartOutput.processInstanceId : this.returnObj.processStartOutput.variables.processInstanceId;
      }else{
        processInstanceId = this.returnObj.processInstanceId ? this.returnObj.processInstanceId : this.returnObj.variables.processInstanceId;
      }
      if(!processInstanceId){
        this.$toast('没有流程id（processInstanceId）！')
        return false;
      }
      processRemove({
        processInstanceId:processInstanceId
      }).then((res) => {
        if (res) {
          if (res.data) {
            if (res.data.code === 200) {
              this.showPopup = false;
              this.$emit('submit', {});
            } else {
              this.$toast(res.data.msg);
            }
            this.innerLoading = false;
          }
        }
      });
    },
    // 下拉框选择单条数据，展示弹框
    getSelect(item) {
      if(!item.readOnly){
        this.itemObj = item;
        this.showPicker = true;
      }
    },
    // 选择数据后，传回父级组件内回显
    getPop(data) {
      this.formFields.map((v) => {
        if (v.name === data.name) {
          v.value = data.value;
        }
      });
    },
    // 时间（年月日）选择器
    getDateSelect(item){
      this.itemObj = item;
      this.showDatePicker = true;
    },
    // 选择数据后，传回父级组件内回显
    getDateTemp(data){
      this.formFields.map((v) => {
        if (v.name === data.name) {
          v.dateValueFlag = false;
        }
      });
    },
    getPopAreaTemp(data){
      this.formFields.map((v) => {
        if (v.name === data.name) {
          v.value = data.value;
        }
      });
    },
    getPopAreaSelect(item){
      // 三级联动下拉框选择，数据需要单独从接口返回
      if(item.params.customDesign.dynamicOptions&&item.params.customDesign.dynamicOptions!==''){
        this.itemObj = item;
        dynamicDataLocation({}).then((res)=>{
          if(res){
            if(!res.data){
              return false;
            }
            if(res.data.areaList){
              this.areaList = res.data.areaList;
              this.showPopAreaPicker = true;
            }
          }
        });
      }
    },
    getNameCheckbox(v){
      if (v.params.customDesign.type === 'select') {
        // 复选框
        if(v.params.customDesign.multiple){
          v.value = this.checkList.join(',');
        }
      }
    },
    getErrorCheckbox(v){
      if (v.params.customDesign.type === 'select') {
        // 复选框
        if(v.params.customDesign.multiple){
          v.value = this.checkErrorList.join(',');
        }
      }
    },
    // 字符串内过滤斜杠/
    removeSlashes(str) {
      return str.replace(/\//g, '');
    },
    validateInput(field){
      // 正则表达式：允许中文、英文、数字、常见标点符号
      const pattern = /^[\u4e00-\u9fa5a-zA-Z0-9\s.,;:!?，。、；：！？'"‘’“”《》【】（）{}\[\]\-—~…]+$/;
      if (field.value && !pattern.test(field.value)) {
        // 自动移除非法字符
        field.value = field.value.replace(/[^\u4e00-\u9fa5a-zA-Z0-9\s.,;:!?，。、；：！？'"‘’“”《》【】（）{}\[\]\-—~…]/g, '');
      }
      if(field.id==='oldAddress'){
        if (field.value.length > this.maxLength) {
          field.value = field.value.slice(0, this.maxLength);
        }
      }else if(field.id==='newAddress'){
        if (field.value.length > this.maxLength) {
          field.value = field.value.slice(0, this.maxLength);
        }
      }else if(field.id==='newaddress'){
        if (field.value.length > this.maxLength) {
          field.value = field.value.slice(0, this.maxLength);
        }
      }else if(field.id==='address'){
        if (field.value.length > this.maxLength) {
          field.value = field.value.slice(0, this.maxLength);
        }
      }else if(field.id==='area'){
        if (field.value.length > this.maxLength) {
          field.value = field.value.slice(0, this.maxLength);
        }
      }
    },
    // 输入框校验
    getRules(field) {
      if (field.required) {
        const baseRules = [
          {
            validator: (val) => this.validateRequired(val, field.name),
            message: `请输入${field.name}`
          }
        ]
        switch (field.id_name) {
          case 'name':
            return [...baseRules,
              {validator: this.validateName, message: '请检查，格式不正确'}
            ]
          case 'phone':
            return [...baseRules,
              {validator: this.validatePhone, message: '请检查，格式不正确'}
            ]
          case 'identity':
            return [...baseRules,
              {validator: this.validateIdCard, message: '请检查，格式不正确'}
            ]
            // case 'num_bank':
            //   return [
            //     ...baseRules,
            //     {validator: this.validateBankNumber1, message: '银行卡号长度不能小于16位'},
            //     {validator: this.validateBankNumber2, message: '银行卡号长度必须在16至19位数之间'},
            //     {validator: this.validateBankNumber3, message: '请检查银行卡号码是否正确'},
            //
            //   ]
          default:
            return baseRules
        }
      }
      // return this.rulesConfig[fieldName] || []
    },
    validateRequired(val) {
      return !(val === null || val === undefined || val === '');
    },
    // 校验姓名
    validateName(val) {
      if (!blurRule(val, {name: 'name'})) {
        return false;
      }
    },
    // 校验手机号
    validatePhone(val) {
      // 只允许输入数字和符号，未校验位数
      // if (!validateInput(val)) {
      //   return false;
      // }
      // 电话号码校验正则
      if(!blurRule(val, {name: 'phone'})){
        return false;
      }
    },
    // 校验身份证号
    validateIdCard(val) {
      if (!blurRule(val, {name: 'idCard'})) {
        return false;
      }
    },
    // // 银行卡号校验
    // validateBankNumber1(value){
    //   if(this.userType === '1'){
    //     // 法人
    //     if(value.length < 16) {
    //       // self.$toast('银行卡号长度不得小于16位')
    //       return false;
    //     }
    //   }
    // },
    // validateBankNumber2(value){
    //   // 自然人和渠道
    //   if(this.userType !== '1'){
    //     if(value.length < 16 || value.length>19) {
    //       // self.$toast('银行卡号长度必须在16至19位数之间')
    //       return false;
    //     }
    //   }
    // },
    // validateBankNumber3(value){
    //   if(this.userType !== '1'){
    //     if(!CheckBankNo(value)){
    //       // 建设银行卡号前6为数校验
    //       return false;
    //     }
    //   }
    // },
    // 图片放大
    showPreview(index, item) {
      ImagePreview({
        images: item,
        startPosition: index,
        closeable: true,
      });
    },
    getWechatLocation(event, index, type) {
      event.preventDefault(); // 阻止默认行为
      let that = this;
      // // 测试数据用   start
      // that.formFields[index].value = this.latitude+','+this.longitude;
      // // 测试数据用   end
      // return false;
      // let url = window.location.href.split('#')[0];
      // if (url) {
      //   // 接口返回appid和签名类的数据
      //   this.$http.weChatScan_preScan({
      //     url: url,
      //   }).then((res) => {
      //     if (res && res.data) {
      //       // 测试本地用
      //     if (type !== 'site') {
      //         // 计算并检查附是否有近网点
      //         that.getFixedLocal(that.latitude, that.longitude, index, type);
      //     } else {
      //         that.formFields[index].value = that.latitude + ',' + that.longitude;
      //       that.getFixedTwoLatLon(index);
      //     }
      //       // console.log('第二步：验证签名接口返回数据，进入wx.config执行');
      //       wx.config({
      //         debug: false, // 开启调试模式,
      //         appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号cor pid
      //         timestamp: res.data.timestamp, // 必填，生成签名的时间戳
      //         nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
      //         signature: res.data.signature,// 必填，签名，见附录1
      //         jsApiList: [
      //           'getLocation',
      //           // 'chooseImage',
      //           // 'scanQRCode',
      //           // 'getLocalImgData',
      //           // 'openCustomerServiceChat',
      //           // 'updateAppMessageShareData',
      //           // 'updateTimelineShareData', // 需要使用的JSAPI列表
      //           // 'onMenuShareTimeline', // 旧版朋友圈分享（兼容）
      //           // 'onMenuShareAppMessage' // 旧版好友分享（兼容）
      //         ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      //       });
      //       wx.ready(() => {
      //         console.log('ggg')
      // -----------
      wx.getLocation({
        type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入' gcj02 '
        isHighAccuracy: true,
        success: function (data) {
          console.log('成功', data);
          if (type !== 'site') {
            that.getFixedLocal(data.latitude, data.longitude, index, type);
          } else {
            that.formFields[index].value = data.latitude + ',' + data.longitude;
            that.getFixedTwoLatLon(index);
          }
        },
        fail: err => {
          that.getConfig(event, index, type);
          console.log('wx.getLocation方法 ，失败');
          console.log('失败', err);
          console.log(err.errMsg);
          if (err.errMsg.includes('user deny')) {
            that.$toast = '您拒绝了位置授权，请前往设置开启';
          } else {
            that.$toast = `获取位置失败：${err.errMsg}`;
          }
        }
      });
      // -----------
      //   });
      //   wx.error(error => {
      //     // this.$toast.fail('验证签名失败，无法获得微信分享功能')
      //     console.error('---wx.config---SDK初始化失败------');
      //     console.error(error)
      //     console.error(error.errMsg)
      //     //   Dialog.alert({
      //     //     title: '获取地理位置失败',
      //     //     message: `
      //     //     <div class="innerDialog">
      //     //       <div style="text-align: left;">点击刷新按钮，系统会给您授权地理位置的提示，请您务必选择允许按钮。</div>
      //     //     </div>`,
      //     //     confirmButtonText: '刷新',
      //     //     theme: 'round-button',
      //     //   }).then(() => {
      //     //     // 刷新页面
      //     //     location.reload();
      //     //   });
      //   });
      //     } else {
      //   that.$toast('请求出错！')
      //   }
      // });
      // }
    },
    getConfig(event, index, type){
      let url = window.location.href.split('#')[0];
      if (url) {
        // 接口返回appid和签名类的数据
        this.$http.weChatScan_preScan({
          url: url,//encodeURIComponent(url),
        }).then((res) => {
          if (res) {
            if (res.code && res.code === 200) {
              wx.config({
                debug: false, // 开启调试模式,
                appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号cor pid
                timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                signature: res.data.signature,// 必填，签名，见附录1
                jsApiList: [
                  'getLocation',
                ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
              });
              wx.ready(() => {
                this.getWechatLocation(event, index, type);
              });
              wx.error(error => {
                console.error('---wx.config---SDK初始化失败------');
                console.error(error)
                console.error(error.errMsg)
              });
            }
          }
        });
      }
    },
    async onSubmit() {
      let that = this;
      if (this.flowNameObj && this.flowNameObj.processDefinitionName) {
        const service = await this.onIsInServiceReturn();
        if (service) {
          Toast('当前网点正在流程中，不可重复操作！');
          return false;
        }
      }
      // 新装机流程-渠道部 审核（审核未通过，无需填写网点编号，审核通过网点编号必填）
      // 新装机流程到渠道审核时，如果"通过"则网点编号必填，如果"不通过"网点编号不用填
      const isEventType = this.formFields?.some(
          field => field.id === 'reviewresult' && (field.value === '通过')
      );
      if (isEventType) {
        const eField = this.formFields.find(item => item.id === 'siteid' ? !item.value : '');
        if (eField) {
          Toast(`请完善 ${eField.name} 信息！`);
          return false;
        }
      }
      //普通表单列表必填项校验
      const emptyField = this.formFields.find(item => item.required ? !item.value : "");
      if (emptyField) {
        if (emptyField.required) {
          that.$toast(`请完善 ${emptyField.name} 信息！`);
          return false;
        }
      }
      // 巡检
      if (this.siteIdObj && this.siteIdObj.processDefinitionName && this.siteIdObj.processDefinitionName.indexOf('一般巡检') !== -1) {
        // 网点是否有代销证
        const isCertificate = this.formFields.find(item => item.id === 'isConsignmentCertificate' ? item.value : '');
        // 拍摄代销证
        const haveCertificate = this.formFields.find(item => item.id === 'shootsConsignmentCertificate' ? !item.value : '');

        if (isCertificate && isCertificate.value === '有') {
          if (haveCertificate) {
            Toast(`请完善 ${haveCertificate.name} 信息！`);
            return false;
          }
        }
        // 新版巡检表单变更 ，2026年四月份 上线新的一般巡检表单内容
        // 是否有代销证
        const certificateIsExist = this.formFields.find(item => item.id === 'certificateIsExist' ? item.value : '');
        // 代销证过期
        const certificateIsValidity = this.formFields.find(item => item.id === 'certificateIsValidity' ? !item.value : '');
        // 上传代销证
        const shootCertificate = this.formFields.find(item => item.id === 'shootCertificate' ? !item.value : '');
        if (certificateIsExist && certificateIsExist.value === '是') {
          if (certificateIsValidity) {
            Toast(`请完善 ${certificateIsValidity.name} 信息！`);
            return false;
          }
          if (shootCertificate) {
            Toast(`请完善 ${shootCertificate.name} 信息！`);
            return false;
          }
        }
        // 是否有门头
        const titleIsExist = this.formFields.find(item => item.id === 'titleIsExist' ? item.value : '');
        // 门头 是否规范
        const storefrontstyle = this.formFields.find(item => item.id === 'storefrontstyle' ? !item.value : '');
        // 上传门头
        const shootTitle = this.formFields.find(item => item.id === 'shootTitle' ? !item.value : '');
        if (titleIsExist && titleIsExist.value === '是') {
          if (storefrontstyle) {
            Toast(`请完善 ${storefrontstyle.name} 信息！`);
            return false;
          }
          if (shootTitle) {
            Toast(`请完善 ${shootTitle.name} 信息！`);
            return false;
          }
        }
        // 网点是否有开奖公告
        const announcementIsExist = this.formFields.find(item => item.id === 'announcementIsExist' ? item.value : '');
        // 上传开奖公告
        const shootAnnouncement = this.formFields.find(item => item.id === 'shootAnnouncement' ? !item.value : '');
        if (announcementIsExist && announcementIsExist.value === '是') {
          if (shootAnnouncement) {
            Toast(`请完善 ${shootAnnouncement.name} 信息！`);
            return false;
          }
        }
        // 网点内是否配备消防设施
        const fireProtectionIsExist = this.formFields.find(item => item.id === 'fireProtectionIsExist' ? item.value : '');
        // 上传配备消防设施
        const shootfireProtection = this.formFields.find(item => item.id === 'shootfireProtection' ? !item.value : '');
        if (fireProtectionIsExist && fireProtectionIsExist.value === '是') {
          if (shootfireProtection) {
            Toast(`请完善 ${shootfireProtection.name} 信息！`);
            return false;
          }
        }

        // 网点在售即开票保安区覆盖膜是否完整
        const welfareLotteryIsFull = this.formFields.find(item => item.id === 'welfareLotteryIsFull' ? item.value : '');
        // 上传网点在售即开票保安区覆盖膜是否完整
        const shootwelfareLotterySecurityArea = this.formFields.find(item => item.id === 'shootwelfareLotterySecurityArea' ? !item.value : '');
        if (welfareLotteryIsFull && welfareLotteryIsFull.value === '否') {
          if (shootwelfareLotterySecurityArea) {
            Toast(`请完善 ${shootwelfareLotterySecurityArea.name} 信息！`);
            return false;
          }
        }

        // 网点待售即开票票面是否有刮痕
        const welfareLotteryIsScratch = this.formFields.find(item => item.id === 'welfareLotteryIsScratch' ? item.value : '');
        // 上传网点待售即开票票面是否有刮痕
        const shootwelfareLotteryIsFront = this.formFields.find(item => item.id === 'shootwelfareLotteryIsFront' ? !item.value : '');
        if (welfareLotteryIsScratch && welfareLotteryIsScratch.value === '否') {
          if (shootwelfareLotteryIsFront) {
            Toast(`请完善 ${shootwelfareLotteryIsFront.name} 信息！`);
            return false;
          }
        }
        // 网点是否有张贴警示语
        const warningIsExist = this.formFields.find(item => item.id === 'warningIsExist' ? item.value : '');
        // 上传网点张贴警示语
        const shootWarning = this.formFields.find(item => item.id === 'shootWarning' ? !item.value : '');
        if (warningIsExist && warningIsExist.value === '是') {
          if (shootWarning) {
            Toast(`请完善 ${shootWarning.name} 信息！`);
            return false;
          }
        }
        // 网点是否有信用销售行为
        const creditSaleIsExist = this.formFields.find(item => item.id === 'creditSaleIsExist' ? item.value : '');
        // 上传网点信用销售行为
        const shootCreditSale = this.formFields.find(item => item.id === 'shootCreditSale' ? !item.value : '');
        if (creditSaleIsExist && creditSaleIsExist.value === '是') {
          if (shootCreditSale) {
            Toast(`请完善 ${shootCreditSale.name} 信息！`);
            return false;
          }
        }
        // 网点内是否有低俗广告
        const vulgarIsExist = this.formFields.find(item => item.id === 'vulgarIsExist' ? item.value : '');
        // 上传网点低俗广告
        const shootVulgar = this.formFields.find(item => item.id === 'shootVulgar' ? !item.value : '');
        if (vulgarIsExist && vulgarIsExist.value === '是') {
          if (shootVulgar) {
            Toast(`请完善 ${shootVulgar.name} 信息！`);
            return false;
          }
        }
        // 新版巡检表单变更 ，2026年五月份 上线新的一般巡检表单内容

        //  店内是否存放易燃、易爆危险品
        const isFlammable = this.formFields.find(item => item.id === 'isFlammable' ? item.value : '');
        //  易燃,易爆危险品拍照
        const isFlammableImage = this.formFields.find(item => item.id === 'isFlammableImage' ? !item.value : '');
        if (isFlammable && isFlammable.value === '是') {
          if (isFlammableImage) {
            Toast(`请完善 ${isFlammableImage.name} 信息！`);
            return false;
          }
        }
        //  店内是否有煤气罐、电动车电池、电动车店内充电
        const isCharging = this.formFields.find(item => item.id === 'isCharging' ? item.value : '');
        //  充电拍照
        const isChargingImage = this.formFields.find(item => item.id === 'isChargingImage' ? !item.value : '');
        if (isCharging && isCharging.value === '是') {
          if (isChargingImage) {
            Toast(`请完善 ${isChargingImage.name} 信息！`);
            return false;
          }
        }
        // 网点内是否存在乱拉乱接电线和电器设备
        const isElectricalAppliances = this.formFields.find(item => item.id === 'isElectricalAppliances' ? item.value : '');
        //    乱拉乱接拍照
        const isElectricalAppliancesImage = this.formFields.find(item => item.id === 'isElectricalAppliancesImage' ? !item.value : '');
        if (isElectricalAppliances && isElectricalAppliances.value === '是') {
          if (isElectricalAppliancesImage) {
            Toast(`请完善 ${isElectricalAppliancesImage.name} 信息！`);
            return false;
          }
        }

        //  网点是否安装摄像头
        const isCamera = this.formFields.find(item => item.id === 'isCamera' ? item.value : '');
        //  网点内摄像头是否由区中心统一安装
        const isCameraUnification = this.formFields.find(item => item.id === 'isCameraUnification' ? !item.value : '');
        // 摄像头拍照
        const isCameraImage = this.formFields.find(item => item.id === 'isCameraImage' ? !item.value : '');
        if (isCamera && isCamera.value === '是') {
          if (isCameraUnification) {
            Toast(`请完善 ${isCameraUnification.name} 信息！`);
            return false;
          }
          if (isCameraImage) {
            Toast(`请完善 ${isCameraImage.name} 信息！`);
            return false;
          }
        }
        //    网点整体环境是否干净整洁，地面桌面无垃圾
        const isTidy = this.formFields.find(item => item.id === 'isTidy' ? item.value : '');
        //    店面拍照
        const isTidyImage = this.formFields.find(item => item.id === 'isTidyImage' ? !item.value : '');
        if (isTidy && isTidy.value === '是') {
          if (isTidyImage) {
            Toast(`请完善 ${isTidyImage.name} 信息！`);
            return false;
          }
        }
      }
      // 移机流程-如果是 5401 开头的网点编号不需要展示和上传移机申请表字段，否则都需要上传移机申请表
      if (this.flowNameObj && this.flowNameObj.processDefinitionName && this.flowNameObj.processDefinitionName.indexOf('移机') !== -1) {
        const siteIdValue = this.formFields.find(item => item.id === 'siteid' ? item.value : '');
        const isRelocationValue = this.formFields.find(item => item.id === 'relocationApplicationForm' ? !item.value : '');
        const newdistrict = this.formFields.find(item => item.id === 'newdistrict' ? !item.value : '');
        if (siteIdValue.value.substring(0, 4) !== '5401') {
          if (isRelocationValue) {
            Toast(`请完善 ${isRelocationValue.name} 信息！`);
            return false;
          }
        }
        // 下面判断似乎没有生效，因为this.flowNameObj对象无数据
        // 专管员角色->专管员判断表单名
        // 新片区字段除了拉萨市和林芝市是必填，其他地市非必填
        if(this.variablesObj&&this.variablesObj.city){
          if (this.variablesObj?.city.includes('拉萨市') || this.variablesObj?.city.includes('林芝市')) {
            if (!newdistrict) {
              Toast(`请完善 ${isRelocationValue.name} 信息！`);
              return false;
            }
          }
        }
      }
      if (this.flowNameObj && this.flowNameObj.processDefinitionName && this.flowNameObj.processDefinitionName.indexOf('代销者变更') !== -1) {
        // 根据网点编号判断是否是拉萨或其他地区，来显示某些字段是否必填
        const siteIdValue = this.formFields.find(item => item.id === 'siteid' ? item.value : '');
        // 变更登记表-changeRegistrationForm
        // 变更申请承接申请-applicationRegardingChanges
        // 新业主承诺书-undertaking
        // 变更代销者资料清单-materialList
        // （除拉萨外必填）
        const changeRegistrationForm = this.formFields.find(item => item.id === 'changeRegistrationForm' ? !item.value : '');
        const applicationRegardingChanges = this.formFields.find(item => item.id === 'applicationRegardingChanges' ? !item.value : '');
        const undertaking = this.formFields.find(item => item.id === 'undertaking' ? !item.value : '');
        const materialList = this.formFields.find(item => item.id === 'materialList' ? !item.value : '');
        // 如果是委托类型则下面的委托资料必填
        const isTypePerson = this.formFields.find(item => item.id === 'processingType' ? item.value !== '自办' : '');
        const powerOfAttorney = this.formFields.find(item => item.id === 'powerOfAttorney' ? !item.value : '');
        const mandaIdentityImage = this.formFields.find(item => item.id === 'mandatorIdentityImage' ? !item.value : '');
        if (siteIdValue.value.substring(0, 4) !== '5401') {
          if (changeRegistrationForm) {
            Toast(`请完善 ${changeRegistrationForm.name} 信息！`);
            return false;
          } else if (applicationRegardingChanges) {
            that.$toast(`请完善 ${applicationRegardingChanges.name} 信息！`);
            return false;
          } else if (undertaking) {
            Toast(`请完善 ${undertaking.name} 信息！`);
            return false;
          } else if (materialList) {
            Toast(`请完善 ${materialList.name} 信息！`);
            return false;
          }
        }
        if (isTypePerson) {
          if (powerOfAttorney) {
            that.$toast(`请完善 ${powerOfAttorney.name} 信息！`);
            return false;
          } else if (mandaIdentityImage) {
            that.$toast(`请完善 ${mandaIdentityImage.name} 信息！`);
            return false;
          }
        }
      }
      this.formFields.map((v) => {
        if (v.socre) {
          v.scoreValueFlag = false;
          v.value = v.socre;
        } else if (v.dateValue) {
          v.dateValueFlag = false;
          v.value = v.dateValue;
        }
        // if(v.required){
        //   if(v.files&&v.files.length<2){
        //     this.$toast(`请完善 ${v.name} 信息！`);
        //     return false;
        //   }
        // }
      });
      // this.innerLoading = true;
      // 提交前已做表单校验
      // 转变格式
      //把数组格式 类似 [{name:'city',value:'拉萨市'},{'name':'siteId',value:'54010001'}]
      //转变为对象 {city:'拉萨市',siteId:'54010001'}
      const result = this.formFields.reduce((obj, item) => {
        obj[item.id] = item.value;
        return obj;
      }, {});
      let processDefinitionName = '';
      if (this.returnObj.processDefinitionName) {
        processDefinitionName = this.returnObj.processDefinitionName;
      } else if (this.siteIdObj.processDefinitionName) {
        processDefinitionName = this.siteIdObj.processDefinitionName;
      } else if (this.flowNameObj.processDefinitionName) {
        processDefinitionName = this.flowNameObj.processDefinitionName;
      }
      this.createObj.processDefinitionName = processDefinitionName;//
      // this.returnObj.processDefinitionName?this.returnObj.processInstanceId:this.returnObj.variables.processInstanceId;
      this.createObj.processInstanceId = this.returnObj.processInstanceId ? this.returnObj.processInstanceId : this.returnObj.variables.processInstanceId;
      this.createObj.formId = this.formDefine.id;
      this.createObj.taskId = this.returnObj.taskId ? this.returnObj.taskId : this.returnObj.variables.taskId;
      this.createObj.values = result;
      console.log('流程名称', processDefinitionName)
      console.log(result, 'result')
      console.log(this.createObj, 'this.createObj')
      // 校验网点录入表单时，库里是否有，如果有，则无法提交，反之，可以提交
      if (processDefinitionName.indexOf('代销者变更') !== -1) {
        let paramsData = {
          city: result.city,//地区、
          identity: result.nowidentity,//身份证、
          phone: result.nowphone,//手机号
          // siteid:result.siteid,//网点
        }
        if (result.city && result.nowidentity && result.nowphone) {
          const bindResult = await this.onIsMobileBindReturn(paramsData);
          if (!bindResult.state) {
            Toast(bindResult.explain);
            return false;
          }
        }
      }
      if (processDefinitionName.indexOf('网点录入') !== -1) {
        let paramsData = {
          city: result.city,//地区、
          identity: result.identity,//身份证、
          phone: result.phone,//手机号
          siteid: result.siteid,//网点
        }
        if (result.city && result.siteid && result.identity && result.phone) {
          const bindResult = await this.onIsMobileBindReturn(paramsData);
          if (!bindResult.state) {
            Toast(bindResult.explain);
            return false;
          }
        }
      }
      if (processDefinitionName.indexOf('新装机') !== -1) {
        // 新装机
        // areyougo是否前往代销者网点字段：仅拉萨市是默认是且不可用户自行选择；
        // precinct片区字段：如果是拉萨市和林芝市必填；其他地市不显示片区字段；
        /*
        * 失信查询不通过，文审资料通过，提交成功了。
        *
        * letdownquery  ： 失信查询
        * 失信查询不通过，文审资料通过，没有做校验。
        *documentReview：文审结果
        * */
        const letdownquery = this.formFields.find(item => item.id === 'letdownquery' ? item.value : '');
        const documentExamine = this.formFields.find(item => item.id === 'documentReview' ? item.value : '');
        if (letdownquery) {
          // 失信查询
          // 失信不通过时，文审结果必须选择不通过，不能选择通过。
          if (letdownquery.value === '未通过') {
            //文审结果
            if (documentExamine) {
              if (documentExamine.value === '通过') {
                Toast(`请检查${documentExamine.name}选项！`);
                return false;
              }
            }
          }
        }
        // 退回文审 选择 否， 复审结果 只能选择 通过；
        // 退回文审 选择 是， 复审结果 只能选择 未通过；
        const backToDocumentView = this.formFields.find(item => item.id === 'backtodocumenteview' ? item.value : '');
        const backReviewResult = this.formFields.find(item => item.id === 'reviewresult' ? item.value : '');
        // 复审结果
        if (backToDocumentView) {
          if (backReviewResult) {
            if (backReviewResult.value === '通过') {
              // 退回文审
              if (backToDocumentView.value === '是') {
                Toast(`请检查${backToDocumentView.name}选项！`);
                return false;
              }
            } else {
              // 复审结果 通过，文审必须选否
              // 复审结果不通过，文审可选是或否，对于阳光征召的申请人来说都是返回到基本资料表单
              // // 退回文审
              // if(backToDocumentView.value === '否'){
              //   Toast(`请检查${backToDocumentView.name}选项！`);
              //   return false;
              // }
            }
          }
        }
        const documentReviewValue = this.formFields.find(item => item.id === 'documentReview' ? item.value : '');
        const errorType = this.formFields.find(item => item.id === 'errorType' ? !item.value : '');
        const precinct = this.formFields.find(item => item.id === 'precinct' ? !item.value : '');
        const precinct_noe = this.formFields.find(item => item.id === 'precinct' ? item.value : '');
        const areyougo = this.formFields.find(item => item.id === 'areyougo' ? !item.value : '');
        // this.variablesObj?.city:从阳光征召提交的数据city字段的值是林芝市、拉萨市、山南市等等
        if (documentReviewValue) {
          // 文审不通过
          if (documentReviewValue.value !== '通过') {
            // 新装机的文审的是否前往代销点字段只有拉萨市不能选，其他的地市都可选
            if (this.variablesObj?.city !== '拉萨市') {
              // 是否前往代销网点
              if (areyougo) {
                Toast(`请完善 ${areyougo.name} 信息！`);
                return false;
              }
            }
            if (errorType) {
              Toast(`请完善 ${errorType.name} 信息！`);
              return false;
            }
          } else {
            // 通过
            // 是否前往代销网点的字段拉萨市，不用校验（默认选择是）；非拉萨市，提示校验；
            if (this.variablesObj?.city !== '拉萨市') {
              // 是否前往代销网点
              if (areyougo) {
                Toast(`请完善 ${areyougo.name} 信息！`);
                return false;
              }
            }
            // const newEditVal =  this.variablesObj?.city === '拉萨市'||this.variablesObj?.city === '林芝市';
            const newEditVal = this.variablesObj?.city.includes('拉萨市') || this.variablesObj?.city.includes('林芝市');
            if (newEditVal) {
              //   如果地市是拉萨市或者林芝市，片区必填，其他的地市不用
              if (precinct) {
                Toast(`请完善 ${precinct.name} 信息！`);
                return false;
              }
              if (precinct_noe) {
                if (precinct_noe.value === '无') {
                  Toast(`请完善 ${precinct_noe.name} 信息！`);
                  return false;
                }
              }
            }
          }
        }
        // 渠道部 审核现场验收 不通过时，必填拒绝类型
        const isAudieType = this.formFields.find(item => item.id === 'auditresult' ? item.value : '');
        const reasonType = this.formFields.find(item => item.id === 'rejectiontype' ? !item.value : '');
        if (isAudieType && isAudieType.value === '拒绝') {
          if (reasonType) {
            Toast(`请完善 ${reasonType.name} 信息！`);
            return false;
          }
        }
      }
      if (processDefinitionName.indexOf('移机') !== -1) {
        // 专管员角色->专管员判断表单名
        // 新片区字段除了拉萨市和林芝市是必填，其他地市非必填
        const newdistrict = this.formFields.find(item => item.id === 'newdistrict' ? !item.value : '');
        if(this.variablesObj&&this.variablesObj.city){
          if (this.variablesObj?.city.includes('拉萨市') || this.variablesObj?.city.includes('林芝市')) {
            if (newdistrict) {
              Toast(`请完善 ${newdistrict.name} 信息！`);
              return false;
            }
          }
        }
      }
      // return false;
      // 坐标距离过远拦截去掉
      // if(this.variablesObj&&this.variablesObj.hiddenCoordinates&&result.noCoord){
      //   const cordResult = await this.fixedLatLon({
      //     coord:this.variablesObj.hiddenCoordinates,
      //     coord1:result.noCoord
      //   });
      //   if(!cordResult.state){
      //     this.$toast(cordResult.explain);
      //     return false;
      //   }
      // }
      //------------------------------------------------
      // let formKey = JSON.parse(this.returnObj.formDefine).key;
      // // 渠道部 审核现场验收
      // if(formKey==='iDMntqyVwyfdkZGhBmuOuRbV0sh8pHnI'){
      //   if(result.auditresult){
      //     this.twoHalt = result.auditresult;
      //   }
      //   this.twoConfirmFlag = true;
      // }else if(formKey==='IEe7oFj82r4g9TCoggOqKek2K6yfXqDK'){
      //   // 渠道部 审核场地勘测
      //   if(result.reviewresult){
      //     this.twoHalt = result.reviewresult;
      //   }
      //   this.twoConfirmFlag = true;
      // }else{
      this.getLastSubmit();
      // }
    },
    getLastSubmit(two) {
      this.twoPermit = true;
      if (this.createObj.taskId && this.createObj.processDefinitionName) {
        processGeneralsubmit(this.createObj).then((res) => {
          if (res) {
            if (res.data) {
              if (res.data.code === 200) {
                if (two) {
                  this.twoPermit = false;
                  this.twoConfirmFlag = false;
                }
                // 传给父组件，调取提交接口
                this.$emit('submit', this.createObj);
                this.$toast.success(res.data.msg);
              } else {
                this.$toast.fail(res.data.msg);
              }
              this.innerLoading = false;
            }
          }
        });
      } else {
        this.innerLoading = false;
        this.$toast('请稍后！');
      }
    }
  }
}
</script>
<template>
  <div>
    <van-popup
        v-model="twoConfirmFlag"
        round
        :close-on-click-overlay="false"
        close-icon-position="top-right"
        position="center" :style="{ width:'90%' }"
    >
      <div class="logs-inner">
        <div class="logs-inner-head">
          提示
        </div>
        <div class="logs-inner-title">
          您确定审核为“{{ twoHalt }}”吗？
        </div>
        <div class="logs-inner-but">
          <van-button round block class="action-btn gay" @click="twoConfirmFlag=false">取消</van-button>
          <van-button round block class="action-btn receive-btn" :disabled="twoPermit" @click="getLastSubmit('two')">
            确定
          </van-button>
        </div>
      </div>
    </van-popup>
    <!--    单选下拉-->
    <Pop v-model="showPicker" :itemObj="itemObj" @submit="getPop"></Pop>
    <!--    时间选择-->
    <Date-temp v-model="showDatePicker" :itemObj="itemObj" @submit="getDateTemp"></Date-temp>
    <!--    级联下拉框-->
    <Pop-Area v-model="showPopAreaPicker" :itemObj="itemObj" :areaList="areaList" @submit="getPopAreaTemp"></Pop-Area>
    <!--  门头照样例  -->
    <van-popup
        v-model="nameHeadFlag"
        round
        :close-on-click-overlay="false"
        :style="{width:'90%' }"
        position="center"
    >
      <div class="staticInner">
        <div class="staticHead">福彩网点门头样例</div>
        <div class="staticImg">
          <img src="@/assets/images/zhao.jpg" alt="图片"/>
        </div>
        <div class="staticFont">红底白字，包含中国福利彩票+藏文+网点编号</div>
        <div class="staticBtn" @click="nameHeadFlag = false">
          <span class="closeBtn">关闭</span>
        </div>
      </div>
    </van-popup>
    <van-popup
        v-model="showPopup"
        round
        :close-on-click-overlay="false"
        position="bottom"
    >
      <!--closeable close-icon-position="top-right" @closed="resetForm"-->
      <van-form @submit="onSubmit">
        <!--    加载中...-->
        <inner-loading v-model="innerLoading"></inner-loading>
        <div class="card-form">
          <div class="fixed-close" @click="cancel">&times;</div>
          <div class="section-title" v-if="formDefine&&formDefine.name">
            {{ formDefine.name.indexOf('巡检') === -1 ? (formDefine.name.split('-')[1] ? formDefine.name.split('-')[1] : formDefine.name.split('-')[0]) : formDefine.name }}
          </div>
          <div class="section-title" v-else>详情信息</div>
          <div class="history-card" v-if="filteredActivities.length>0">
            <div class="card" v-for="(v,index) in filteredActivities" :key="index">
              <div class="card-title-item" v-if="v&&v.taskName">{{ v.taskName }} - {{ v.handler }}</div>
              <div class="info-form-group" v-if="v&&v.formInfo&&v.formInfo.fields" v-for="(item,k) in v.formInfo.fields"
                   :key="k">
                <div class="info-form-item">
                  <div class="info-label-content">{{ item.name }}：</div>
                  <div class="info-text-content" v-if="item.params.customDesign.type==='rate'">
                    <van-rate
                        v-model="item.value"
                        :readonly="item.readOnly"
                        :size="25"
                        :count="5"
                        color="#ffd21e"
                        void-icon="star"
                        void-color="#eee"
                    />
                  </div>
                  <div v-else-if="item.params.customDesign.type==='fileupload'" class="imageEnd">
                    <div class="group-video-his" v-if="item.files.length>0">
                      <div class="group-video-load-his">
                        <van-image
                            v-for="(val,kes) in item.files" :key="kes"
                            :src="val"
                            @click="showPreview(kes,item.files)"
                        />
                      </div>
                    </div>
                    <div v-else>未填写说明</div>
                  </div>
                  <div class="info-text-content" v-else>
                    <span v-if="item.id==='phone'">
                      <a :href="'tel:'+item.value">{{ item.value }}</a>
                    </span>
                    <span v-else-if="item.id==='distributorsphone'">
                      <a :href="'tel:'+item.value">{{ item.value }}</a>
                    </span>
                    <span v-else-if="item.id==='distributorphone'">
                      <a :href="'tel:'+item.value">{{ item.value }}</a>
                    </span>
                    <span v-else-if="item.id==='previousphone'">
                      <a :href="'tel:'+item.value">{{ item.value }}</a>
                    </span>
                    <!--新代销者手机号-->
                    <span v-else-if="item.id==='nowphone'">
                      <a :href="'tel:'+item.value">{{ item.value }}</a>
                    </span>
                    <!--                    新装机-->
                    <span v-else-if="item.id==='reviewresult'">
                      <span v-if="item.value&&item.value.indexOf('不符合')!==-1"
                            class="red">{{ item.value ? removeSlashes(item.value) : '未填写说明' }}</span>
                      <span v-else-if="item.value&&item.value.indexOf('不通过')!==-1"
                            class="red">{{ item.value ? removeSlashes(item.value) : '未填写说明' }}</span>
                      <span v-else-if="item.value&&item.value.indexOf('未通过')!==-1"
                            class="red">{{ item.value ? removeSlashes(item.value) : '未填写说明' }}</span>
                      <span v-else-if="item.value&&item.value.indexOf('不同意')!==-1"
                            class="red">{{ item.value ? removeSlashes(item.value) : '未填写说明' }}</span>
                      <span v-else-if="item.value&&item.value.indexOf('拒绝')!==-1"
                            class="red">{{ item.value ? removeSlashes(item.value) : '未填写说明' }}</span>
                      <span v-else class="green">{{ item.value ? removeSlashes(item.value) : '未填写说明' }}</span>
                    </span>
                    <!--                     特殊巡检  网点录入  撤机 移机 经营类型变更 代销者变更 （地址）信息更正 -->
                    <span v-else-if="item.id==='auditresult'">
                      <span v-if="item.value&&item.value.indexOf('不符合')!==-1"
                            class="red">{{ item.value ? removeSlashes(item.value) : '未填写说明' }}</span>
                      <span v-else-if="item.value&&item.value.indexOf('不通过')!==-1"
                            class="red">{{ item.value ? removeSlashes(item.value) : '未填写说明' }}</span>
                      <span v-else-if="item.value&&item.value.indexOf('未通过')!==-1"
                            class="red">{{ item.value ? removeSlashes(item.value) : '未填写说明' }}</span>
                      <span v-else-if="item.value&&item.value.indexOf('不同意')!==-1"
                            class="red">{{ item.value ? removeSlashes(item.value) : '未填写说明' }}</span>
                      <span v-else-if="item.value&&item.value.indexOf('拒绝')!==-1"
                            class="red">{{ item.value ? removeSlashes(item.value) : '未填写说明' }}</span>
                      <span v-else class="green">{{ item.value ? removeSlashes(item.value) : '未填写说明' }}</span>
                    </span>
                    <span v-else>
<!--                      <span v-if="item.value&&item.value.indexOf('不符合')!==-1" class="red">{{ item.value ? removeSlashes(item.value) : '未填写说明' }}</span>-->
                      <!--                      <span v-else-if="item.value&&item.value.indexOf('不通过')!==-1" class="red">{{ item.value ? removeSlashes(item.value) : '未填写说明' }}</span>-->
                      <!--                      <span v-else-if="item.value&&item.value.indexOf('未通过')!==-1" class="red">{{ item.value ? removeSlashes(item.value) : '未填写说明' }}</span>-->
                      <!--                      <span v-else-if="item.value&&item.value.indexOf('不同意')!==-1" class="red">{{ item.value ? removeSlashes(item.value) : '未填写说明' }}</span>-->
                      <!--                      <span v-else-if="item.value&&item.value.indexOf('拒绝')!==-1" class="red">{{ item.value ? removeSlashes(item.value) : '未填写说明' }}</span>-->
                      <!--                      <span v-else-if="item.value&&item.value.indexOf('符合')!==-1" class="green">{{ item.value ? removeSlashes(item.value) : '未填写说明' }}</span>-->
                      <!--                      <span v-else-if="item.value&&item.value.indexOf('通过')!==-1" class="green">{{ item.value ? removeSlashes(item.value) : '未填写说明' }}</span>-->
                      <!--                      <span v-else-if="item.value&&item.value.indexOf('同意')!==-1" class="green">{{ item.value ? removeSlashes(item.value) : '未填写说明' }}</span>-->
                      <!--                      <span v-else>{{ item.value ? removeSlashes(item.value) : '未填写说明' }}</span>-->
                      {{ item.value ? removeSlashes(item.value) : '未填写说明' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="" v-for="(v,k) in userUpdateForm" :key="k" v-if="userUpdateForm.length>0">
            <div class="form-item" v-for="(item,index) in v.fields" :key="index">
              <!--<div>{{item.id}}</div>-->
              <!-- <div>{{item.params.customDesign.type}}</div>-->
              <div class="form-label" style="font-weight: bold">
                {{ item.name }}
                <span style="color: red" v-show="item.required">*</span>
                <span style="padding-left: 10px;vertical-align: middle" v-show="formDefine.name.indexOf('巡检')!==-1"
                      @click="getCheck(item)">
                  <van-icon name="question-o"/>
                </span>
                <div class="info-tooltip" v-show="resultData.fieldId===item.id">
                  <div class="info-tooltip-content">
                    <div v-for="(val,key) in explainList" :key="key">{{ val }}</div>
                  </div>
                </div>
                <div class="info-tooltip" v-show="resultData_van.fieldId===item.id">
                  <div class="info-tooltip-content">
                    {{ item.name }} 暂无说明
                  </div>
                </div>
                <span style="color:red" v-if="item.id==='identificationPhoto'">（上传近半年二寸白底证件照片）</span>
                <!-- 移机流程-场地勘测表单里的-根据经纬度查询附近网点   -->
                <div v-if="item.id==='isSiteid'" style="display: inline-block;margin-left: 20px;float: right;">
                  <button class="verification-button">
                    <span @click.prevent="getWechatLocation($event,index,'noSite')">检查附近网点</span>
                  </button>
                </div>
              </div>
              <div v-if="item.params.customDesign.type==='input'">
                <!-- 经纬度字段单独处理-->
                <div v-if="item.id==='coord'" class="verification-group">
                  <input type="text" class="form-input verification-input" style="background: #dfdfdf;"
                         autocomplete="off"
                         readonly="readOnly" v-model="item.value" placeholder="获取经纬度信息"/>
                  <button class="verification-button" :class="item.value?'ver-success':''">
                  <span
                      @click.prevent="getWechatLocation($event,index,'fixed-site')">{{
                      item.value ? '已获取' : '获取定位'
                    }}</span>
                  </button>
                </div>
                <!-- 新装机-场地勘测-获取定位-->
                <div v-else-if="item.id==='noCoord'||item.id==='hiddenCoordinates'" class="verification-group">
                  <input type="text" class="form-input verification-input" style="background: #dfdfdf;"
                         autocomplete="off"
                         readonly="readOnly" v-model="item.value" placeholder="获取经纬度信息"/>
                  <button class="verification-button" :class="item.value?'ver-success':''">
                  <span
                      @click.prevent="getWechatLocation($event,index,'site')">{{
                      item.value ? '已获取' : '获取定位'
                    }}</span>
                  </button>
                </div>

                <van-field
                    v-model="item.value"
                    name="name"
                    label=""
                    v-else
                    :type="item.id_name==='phone'?'number':(item.id==='siteid'?'digit':'')"
                    autocomplete="off"
                    :disabled="item.readOnly"
                    :readonly="item.readOnly"
                    @input="validateInput(item)"
                    :placeholder="`${item.params.customDesign.placeholder}${item.name}`"
                    :rules="item.required?getRules(item):[]"
                />
              </div>
              <div v-else-if="item.params.customDesign.type==='textarea'">
                <van-field
                    v-if="item.id==='area'||item.id==='address'||item.id==='oldAddress'||item.id==='newAddress'||item.id==='newaddress'"
                    v-model="item.value"
                    name="name"
                    label=""
                    autocomplete="off"
                    :disabled="item.readOnly"
                    :readonly="item.readOnly"
                    type="textarea"
                    @input="validateInput(item)"
                    :placeholder="`${item.params.customDesign.placeholder}${item.name}`"
                    :rules="item.required?getRules(item):[]"
                    rows="2"
                    autosize
                    :maxlength="maxLength"
                    show-word-limit
                />
                <van-field
                    v-else
                    v-model="item.value"
                    name="name"
                    label=""
                    autocomplete="off"
                    :disabled="item.readOnly"
                    :readonly="item.readOnly"
                    type="textarea"
                    @input="validateInput(item)"
                    :placeholder="`${item.params.customDesign.placeholder}${item.name}`"
                    :rules="item.required?getRules(item):[]"
                />
              </div>
              <div v-else-if="item.params.customDesign.type==='cascader'">
                <van-field
                    :readonly="item.readonly"
                    clickable
                    name="area"
                    v-model="item.value"
                    label=""
                    :placeholder="`${item.name}`"
                    :rules="[{ required: true, message: `${item.name}` }]"
                    right-icon="arrow"
                    @click="getPopAreaSelect(item)"
                ></van-field>
              </div>
              <div v-else-if="item.params.customDesign.type==='select'">
                <van-field
                    v-model="item.value"
                    v-if="!item.params.customDesign.multiple"
                    name=""
                    label=""
                    clickable
                    :disabled="item.readOnly"
                    readonly
                    :placeholder="`${item.params.customDesign.placeholder}${item.name}`"
                    @click="getSelect(item)"
                    :rules="[{ required: true, message: `${item.params.customDesign.placeholder}${item.name}` }]"
                >
                  <template #right-icon>
                    <van-icon name="arrow-down"/>
                  </template>
                </van-field>
                <div v-else-if="item.id==='surveyor'">
                  <van-checkbox-group v-model="checkList" direction="horizontal" @change="getNameCheckbox(item)">
                    <van-checkbox style="margin-bottom: 10px" shape="square" checked-color="#e62d2d" :name="v.value"
                                  v-for="(v,k) in checkName"
                                  :key="k">{{ v.value }}
                    </van-checkbox>
                  </van-checkbox-group>
                  <!--                <van-checkbox-group v-model="item.checkList" direction="horizontal" @change="getNameCheckbox(item)">-->
                  <!--                  <van-checkbox style="margin-bottom: 10px" shape="square" :name="v.value" v-for="(v,k) in item.checkName" :key="k">{{v.value}}</van-checkbox>-->
                  <!--                </van-checkbox-group>-->
                </div>
                <div v-else-if="item.id==='errorType'">
                  <!--错误类型类型-->
                  <van-checkbox-group class="check-group-flex" v-model="checkErrorList"
                                      @change="getErrorCheckbox(item)">
                    <div class="check-column" v-for="(v,index) in item.checkTypeValue" :key="index">
                      <div class="check-column-item" v-if="v.list.length>0">
                        <div class="check-label" v-if="v.list.length>0"><span style="display: flex;margin-right:5px"><van-icon
                            name="description"/></span>{{ v.title }}
                        </div>
                        <div class="group-video-his" v-if="v.list.length>0">
                          <div class="group-video-load-his">
                            <div style="display: inline-block" v-for="(val,kes) in v.image" :key="kes" v-if="val.value">
                              <van-image
                                  v-for="(a,b) in val.value.split(',')" :key="b"
                                  :src="a"
                                  @click="showPreview(b,val.value.split(','))"
                              />
                            </div>
                          </div>
                        </div>
                        <div v-if="v.image">审核意见：</div>
                        <div class="check-grid">
                          <van-checkbox class="check-val" shape="round" checked-color="#e62d2d" v-for="(i,k) in v.list"
                                        :key="k" :name="i.label">{{ i.label }}
                          </van-checkbox>
                        </div>
                      </div>
                    </div>
                  </van-checkbox-group>
                </div>
                <div v-else>
                  <van-checkbox-group v-model="checkErrorList" direction="horizontal" @change="getErrorCheckbox(item)">
                    <van-checkbox style="margin-bottom: 10px" shape="square" checked-color="#e62d2d" :name="v.label"
                                  v-for="(v,k) in item.params.customDesign.values"
                                  :key="k">{{ v.label }}
                    </van-checkbox>
                  </van-checkbox-group>
                </div>
              </div>
              <div v-else-if="item.params.customDesign.type==='radio'"
                   style="display: flex;flex-direction: column;justify-content: space-between">
                <div v-if="item.id==='letdownquery'" class="info-form-item-group">
                  <div class="info-form-group">
                    <div class="info-text-content">{{ variablesObj.name }}</div>
                    <div class="info-text-content">{{ variablesObj.identity }}</div>
                    <div @click="handleCopy" v-show="variablesObj.identity" class="copy-button">复制</div>
                  </div>
                  <div class="info-form-group btm">
                    <a href="https://zxgk.court.gov.cn/shixin/" target="_self"
                       style="color: #2196f3">无不良信用记录[查询链接] </a>
                  </div>
                </div>
                <div style="padding-bottom: 10px;color: #2196f3;" v-if="item.id==='issiteaddress'">
                  (网点地址：{{ siteIdInfoObj.address }})
                </div>
                <van-radio-group v-if="formDefine&&formDefine.name.indexOf('移机')!==-1&&item.id==='city'"
                                 v-model="item.value" direction="horizontal" :disabled="item.readOnly"
                                 style="display: flex;align-items: center">
                  <van-radio :name="val.label" v-for="(val,k) in item.params.customDesign.values" :key="k"
                             :disabled="val.disabled">
                    {{ val.label }}
                  </van-radio>
                </van-radio-group>
                <van-radio-group
                    v-else-if="formDefine&&formDefine.name.indexOf('经营类型')!==-1&&item.id==='new_management_kind'"
                    v-model="item.value" direction="horizontal" :disabled="item.readOnly"
                    style="display: flex;align-items: center">
                  <van-radio :name="val.label" v-for="(val,k) in item.params.customDesign.values" :key="k"
                             :disabled="val.disabled">
                    {{ val.label }}
                  </van-radio>
                </van-radio-group>
                <div style="display: flex;flex-flow: row;justify-content: space-between" v-else>
                  <van-radio-group v-model="item.value" direction="horizontal" :disabled="item.readOnly"
                                   style="display: flex;align-items: center">
                    <van-radio :name="val.label" v-for="(val,k) in item.params.customDesign.values" :key="k">
                      {{ val.label }}
                    </van-radio>
                  </van-radio-group>
                  <span v-if="item.id==='storefrontstyle'" style="color: #2196f3;vertical-align: middle"
                        @click="nameHeadFlag = true">查看门头样例<van-icon style="margin-left:4px;" name="question-o"/></span>
                </div>
                <!-- 移机流程-场地勘测表单里的-根据经纬度查询附近网点   -->
                <!-- 检查附近网点-->
                <div v-if="item.id==='isSiteid'" style="float: right">
                  <span v-if="!item.valuesFlags" style="color:red;text-align: right">{{ item.valueMsg }}</span>
                  <span v-else style="color:green;">{{ item.valueMsg }}</span>
                </div>
              </div>
              <div v-else-if="item.params.customDesign.type==='rate'">
                <van-rate
                    v-if="item.scoreValueFlag"
                    v-model="item.value"
                    :size="25"
                    :count="5"
                    color="#ffd21e"
                    void-icon="star"
                    void-color="#eee"
                    @change="onChange(index)"
                />
                <van-rate
                    v-else
                    v-model="item.scoreValue"
                    :size="25"
                    :count="5"
                    color="#ffd21e"
                    void-icon="star"
                    void-color="#eee"
                    @change="onValueChange"
                />
              </div>
              <!--   年月日格式：yyyy-mm-dd -->
              <div v-else-if="item.params.customDesign.type==='date'">
                <van-field
                    v-model="item.value"
                    v-if="item.dateValueFlag"
                    name=""
                    label=""
                    readonly
                    :placeholder="`${item.params.customDesign.placeholder}${item.name}`"
                    @click="getDateSelect(item,'value')"
                    :rules="[{ required: true, message: `${item.params.customDesign.placeholder}${item.name}` }]"
                >
                  <template #right-icon>
                    <van-icon name="arrow-down"/>
                  </template>
                </van-field>
                <van-field
                    v-model="item.dateValue"
                    v-else
                    name=""
                    label=""
                    readonly
                    :placeholder="`${item.params.customDesign.placeholder}${item.name}`"
                    @click="getDateSelect(item,'dateValue')"
                    :rules="[{ required: true, message: `${item.params.customDesign.placeholder}${item.name}` }]"
                >
                  <template #right-icon>
                    <van-icon name="arrow-down"/>
                  </template>
                </van-field>
              </div>
              <div v-else-if="item.params.customDesign.type==='fileupload'">
                <div class="group-video">
                  <div class="group-video-load">
                    <el-upload
                        class="avatar-uploader"
                        :action="fileVideoUrl"
                        :headers="headers"
                        :limit="2"
                        multiple
                        :file-list="item.files"
                        accept="image/jpeg, image/jpg, image/png"
                        list-type="picture-card"
                        :on-exceed="handleExceed"
                        :on-success="(response, file, fileList) => handleSuccess(response, file, fileList, index,item)"
                        :before-upload="beforeUploadImg1"
                        :on-remove="(file, fileList) => handleRemove(file, fileList, index)">
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-buttons">
            <van-button round block plain type="default" @click="cancel" style="background: #f5f5f5;border:none;"
                        native-type="button">{{ content === 'del' ? '取消' : '关闭' }}
            </van-button>
            <van-button round block type="primary" color="#e62d2d" :disabled="disabledSubmitFlag"
                        v-if="content==='del'||submitText==='提交'"
                        native-type="submit">提交
            </van-button>
          </div>
        </div>
      </van-form>
    </van-popup>
  </div>
</template>

<style scoped lang="scss">

.logs-inner {
  .logs-inner-head {
    padding: 30px 30px 30px;
    font-weight: bold;
    font-size: 30px;
    border-bottom: 1px solid #ddd;
    text-align: center;
  }

  .logs-inner-title {
    padding: 40px 50px;
    font-size: 30px;
    text-align: center;
  }

  .logs-inner-but {
    display: flex;
    justify-content: space-between;
    padding: 0 40px 40px;

    .van-button {
      width: 45%;
    }

    .action-btn {
      padding: 20px 20px;
      border-radius: 18px;
      border: none;
      cursor: pointer;
      margin-top: 40px;
    }

    .gay {
      border: 2px solid #ddd;
      color: #ccc;
    }

    .receive-btn {
      background-color: #e62d2d;
      //background: linear-gradient(45deg, #FF6B6B, #FF8E8E);
      color: white;
    }
  }
}

.staticInner {
  padding: 20px;

  .staticHead {
    font-weight: bold;
    font-size: 32px;
    padding: 20px 20px 30px;
    text-align: center;
    border-bottom: 2px solid #ddd;
  }

  .staticImg {
    background: #fff;
    text-align: center;
    border-radius: 30px;
    padding: 20px 0;
    border: none;
    box-shadow: none;

    img {
      height: 100px;
      width: 100%;
    }
  }

  .staticFont {
    color: red;
    padding: 0 20px 40px;
  }

  .staticBtn {
    text-align: center;

    .closeBtn {
      display: inline-block;
      font-size: 26px;
      padding: 20px 100px;
      border: 2px solid #ddd;
      border-radius: 50px;
      color: #999;
    }
  }
}

.iframe-wrap {
  height: 100%;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: red;
  z-index: 100000;

  .iframe-wrap-head {
    height: 10%;
  }

  .iframe-wrap-group {
    height: 80%;
    width: 100%;
    background: yellow;
  }
}

.loading {
  z-index: 9999;
}

.history-card {
  padding: 10px 0 20px;
  border-bottom: 2px solid #ddd;
  margin-bottom: 20px;

  .card-title-item {
    text-align: left;
    font-weight: bold;
    padding-bottom: 10px;
    margin-bottom: 10px;
    font-size: 32px;
    border-bottom: 2px #ddd dashed;
  }
}

.card {
  box-shadow: var(--shadow-blod);
}

.card-form {
  padding: 0 40px;
  box-sizing: border-box;

  .fixed-close {
    position: absolute;
    right: 50px;
    top: 1px;
    font-size: 50px;
    color: #999;
  }
}

.section-title {
  padding-top: 20px;
  padding-bottom: 20px;
  justify-content: center;
  border-bottom: 2px solid rgba(0, 0, 0, 0.05);
}

.van-cell {
  background: #f9f9f9;
}

.form-item {
  //position: relative;
  .check-group-flex {
    display: flex;
    flex-direction: column;

    .check-column {
      display: flex;
      flex-direction: column;

      .check-column-item {
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.10);
        margin-bottom: 20px;
        border-radius: 10px;
        padding: 20px 20px;

        .check-label {
          display: flex;
          align-items: center;
          padding-bottom: 20px;
          color: oklch(14.5% 0 0);
          font-weight: bold;
        }

        .group-video-his {
          display: flex;
          justify-content: flex-start;
          flex-direction: column;
          width: 100%;

          .group-video-load-his {

            /deep/ .van-image__img {
              display: inline-block;
              width: 100px;
              height: 130px;
              margin-left: 10px;
              border: 2px solid #ddd;
            }
          }
        }

        .check-grid {
          display: grid;
          gap: 10px;
          //grid-template-columns: 0fr 0fr;
          margin-bottom: 10px;

          .check-val {
            display: flex;
            flex: 1;
            width: 100%;
            margin-right: 20px
          }
        }
      }
    }
  }

  .info-tooltip {
    //position: absolute;
    //left: 0;
    //top: 40px;
    //z-index: 10;
    //background:  rgba(230, 45, 45, 0.2);
    border: 3px solid rgba(230, 45, 45, 0.2);
    border-radius: 10px;
    padding: 12px;
    margin-bottom: 18px;
    //font-size: 13px;
    color: var(--text-light);
    line-height: 1.6;
    box-shadow: var(--shadow-md);
    animation: fadeIn 0.3s ease;
  }

  .info-tooltip-content {
    position: relative;
    padding-left: 15px;
    font-size: 24px;
    font-weight: normal;
  }

  //.info-tooltip-content:before {
  //content: '';
  //position: absolute;
  //left: 0;
  //top: 0;
  //bottom: 0;
  //width: 3px;
  //background: var(--primary-color);
  //border-radius: 2px;
  //}
}

.info-form-group {
  display: flex;
  flex-direction: column;

  .info-form-item {
    width: 100%;
    display: flex;
    flex-direction: row;

    .info-label-content {
      display: flex;
      font-weight: bold;
      color: #222;
      width: 50%;
    }

    .info-text-content {
      display: flex;
      width: 50%;
      justify-content: flex-end;
      align-items: flex-start;
      word-wrap: break-word;
      white-space: normal;

      span {
        word-break: break-word;
        text-align: right;
      }

      .red {
        color: #e62d2d;
      }

      .green {
        color: #4caf50;
      }
    }

    .imageEnd {
      display: flex;
      width: 50%;
      justify-content: flex-end;
      align-items: flex-start;

      .group-video-his {
        display: flex;
        justify-content: flex-end;
        flex-direction: column;
        width: 100%;

        .group-video-load-his {
          text-align: right;

          /deep/ .van-image__img {
            display: inline-block;
            width: 100px;
            height: 130px;
            margin-left: 10px;
            border: 2px solid #ddd;
          }
        }
      }
    }
  }
}

.group-video {
  border-radius: 8px;
  //height: 26vw;
  //height: 260px;
  position: relative;

  .group-video-load {
    position: relative;
    border-radius: 10px;
    height: 100%;
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: row;

    .van-image {
      display: flex;
      max-width: 240px;
      height: 180px;
      border-radius: 8px;
      margin-right: 20px;

      /deep/ .van-image__img {
        display: flex;
        max-width: 240px;
        max-height: 170px;
        border-radius: 8px;
      }
    }

    .image-box {
      max-width: 240px;
      height: 180px;
      border-radius: 8px;
      margin-right: 20px;

      img {
        display: flex;
        max-width: 240px;
        max-height: 170px;
        border-radius: 8px;
      }
    }

    .avatar-uploader {
      display: flex;
      width: 100%;
      height: 100%;
      align-items: center;
      overflow: hidden;

      .el-upload {
        width: 100%;
        height: 100%;
      }
    }
  }
}

.info-form-item-group {
  display: flex;
  flex-direction: column;

  .info-form-group {
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;

    .info-label-content {
      display: flex;
      color: #222;
    }

    .info-text-content {
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;
      word-wrap: break-word;
      white-space: normal;
      padding: 0 20px 0 0;
      text-align: right;
    }

    .copy-button {
      background: #2196f3;
      color: #fff;
      padding: 5px 20px;
      border-radius: 10px;
    }
  }

  .btm {
    margin-bottom: 20px;
  }
}

/deep/ .el-upload-list--picture-card .el-progress {
  width: 100%;

  /deep/ .el-progress__text {
    text-align: center;
  }
}

/deep/ .el-progress-circle {
  width: 130px !important;
  height: 130px !important;
  margin: 0 auto;
}
</style>